import type { Dict } from './uk'
import { fopsEn } from './fops'
import { labshipEn } from './labship'
import { incidentsEn } from './incidents'
import { arrivalsEn } from './arrivals'
import { bloodbankEn } from './bloodbank'
import { supplyEn } from './supply'
import { supplyEnoteEn } from './supplyEnote'
import { kbEn } from './kb'
import { registersEn } from './registers'
import { cashopsEn } from './cashops'
import { checkboxEn } from './checkbox'
import { basEn } from './bas'
import { callcenterEn } from './callcenter'
import { fincontrolEn } from './fincontrol'
import { mgmtEn } from './mgmt'
import { consentsEn } from './consents'
import { vritEnoteEn } from './vritenote'
import { pwaEn } from './pwa'
import { rolloutEn } from './rollout'
import { callqualityEn } from './callquality'
import { clinqEn } from './clinq'
import { moneyEn } from './money'
import { personnelEn } from './personnel'
import { registryEn } from './registry'
import { helpEn } from './help'

/* English dictionary. Missing keys fall back to Ukrainian. */
export const en: Partial<Dict> = {
  ...fopsEn,
  ...labshipEn,
  ...incidentsEn,
  ...arrivalsEn,
  ...bloodbankEn,
  ...supplyEn,
  ...supplyEnoteEn,
  ...kbEn,
  ...registersEn,
  ...cashopsEn,
  ...checkboxEn,
  ...basEn,
  ...callcenterEn,
  ...fincontrolEn,
  ...mgmtEn,
  ...consentsEn,
  ...vritEnoteEn,
  ...rolloutEn,
  ...pwaEn,
  ...callqualityEn,
  ...clinqEn,
  ...moneyEn,
  ...personnelEn,
  ...registryEn,
  ...helpEn,
  'common.actions': 'Actions',
  'common.all': 'All',
  'common.any': 'Any',
  'common.apply': 'Apply',
  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.copied': 'Copied',
  'common.copy': 'Copy',
  'common.copyFailed': 'Could not copy',
  'common.delete': 'Delete',
  'common.done': 'Done',
  'common.edit': 'Edit',
  'common.failed': 'Failed',
  'common.me': 'me',
  'common.min': 'min',
  'common.no': 'no',
  'common.noData': 'No data yet',
  'common.nothingFound': 'Nothing found',
  'common.ok': 'OK',
  'common.open': 'Open',
  'common.openAll': 'Open all',
  'common.reset': 'Reset',
  'common.retry': 'Try again',
  'common.save': 'Save',
  'common.updating': 'Updating…',
  'common.undo': 'Undo',
  'common.yes': 'yes',

  'nav.main': 'Main navigation',
  'nav.today': 'Today',
  'nav.schedule': 'Schedule',
  'nav.journeys': 'Journeys',
  'nav.linkReview': 'Link review',
  'nav.clients': 'Clients & Pets',
  'nav.doctor': 'Doctor',
  'nav.calls': 'Calls',
  'nav.missed': 'Missed opportunities',
  'nav.inbox': 'Inbox',
  'nav.finance': 'Finance',
  'nav.quality': 'Quality',
  'nav.marketing': 'Marketing',
  'nav.tasks': 'Tasks',
  'nav.insights': 'Insights',
  'nav.admin': 'Admin',
  'nav.users': 'Users & roles',
  'nav.connectors': 'Connectors',
  'nav.sync': 'Sync',
  'nav.jobs': 'Jobs',
  'nav.rooms': 'Rooms & cameras',
  'nav.operators': 'Operators',
  'nav.clientapp': 'Client app',
  'nav.settings': 'Settings',
  'nav.audit': 'Audit log',
  'nav.system': 'System status',
  'nav.profile': 'Profile',
  'nav.collapse': 'Collapse',
  'nav.expand': 'Expand',
  'nav.openMenu': 'Open menu',

  'search.open': 'Search and commands',
  'search.placeholder': 'Search clients, pets, phones, actions…',
  'search.paletteHint': 'Type a name, phone, pet or command…',
  'search.nothing': 'Nothing found',
  'search.results': 'Results',
  'search.quick': 'Quick actions',
  'search.navigation': 'Go to',
  'search.actions': 'Actions',
  'search.moduleMissing': 'Global search is not connected yet — navigation and actions are available.',
  'search.toggleTheme': 'Toggle theme',
  'search.type.client': 'client',
  'search.type.pet': 'pet',
  'search.type.call': 'call',
  'search.type.task': 'task',
  'search.type.visit': 'visit',
  'search.type.appointment': 'appointment',

  'state.moduleMissing': 'Module not connected yet',
  'state.moduleMissingHint': 'This section will work as soon as the server exposes the action',
  'state.noAccess': 'No access',
  'state.noAccessHint': 'Your role cannot use this section. Ask an administrator.',
  'state.error': 'Something went wrong',
  'state.notFound': 'Page not found',
  'state.notFoundHint': 'The link may be outdated or the page has moved.',
  'state.goHome': 'Go home',
  'error.generic': 'Something went wrong. Please try again.',
  'error.moduleMissing': 'Module not connected yet',
  'error.forbidden': 'You do not have permission for this action',
  'error.network': 'Cannot reach the server',
  'error.rateLimited': 'Too many attempts. Wait a minute.',
  'error.lastAdmin': 'You cannot remove the role from or disable the last active super admin. Assign another one first.',
  'error.emailTaken': 'A user with this email already exists',
  'error.locked': 'Too many failed attempts. The account is locked for 15 minutes.',
  'error.inviteInvalid': 'The invitation is invalid or expired. Ask an administrator for a new one.',
  'error.passwordPolicy': 'The password does not meet the policy',
  'error.currentPassword': 'Current password is incorrect',
  'error.totpInvalid': 'Invalid verification code',
  'validation.required': 'Required',
  'validation.email': 'Invalid email',
  'validation.invalid': 'Invalid value',
  'validation.max': 'At most {n} characters',
  'validation.maxValue': 'At most {n}',
  'validation.min': 'At least {n}',

  'login.title': 'Staff sign-in',
  'login.subtitle': 'Use your clinic work email',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.submit': 'Sign in',
  'login.verify': 'Verify',
  'login.invalid': 'Invalid email or password',
  'login.totpTitle': 'Two-factor check',
  'login.totpHint': 'Enter the 6-digit code from your authenticator app.',
  'login.totpCode': 'Verification code',
  'login.inviteOnly': 'Access by administrator invitation only.',
  'login.heroTitle': 'The whole visit story in one place',
  'login.heroText': 'Calls, bookings, exam room, treatment, payment and recommendations — linked into one patient journey.',
  'invite.title': 'Welcome to Dovira',
  'invite.subtitle': 'Create a password to activate your account.',
  'invite.password': 'New password',
  'invite.confirm': 'Repeat password',
  'invite.submit': 'Activate account',
  'invite.mfaNote': 'After signing in, turn on two-factor authentication in your profile.',
  'invite.doneTitle': 'Account activated',
  'invite.doneText': 'Now sign in as {email}.',
  'invite.goLogin': 'Go to sign-in',
  'password.rules': 'Password requirements',
  'password.ruleLength': 'at least 10 characters',
  'password.ruleUpper': 'an uppercase letter',
  'password.ruleLower': 'a lowercase letter',
  'password.ruleDigit': 'a digit',
  'password.policy': 'The password does not meet the requirements',
  'password.mismatch': 'Passwords do not match',

  'user.menu': 'User menu',
  'user.profile': 'My profile',
  'user.language': 'Language',
  'user.theme': 'Theme',
  'user.shortcuts': 'Keyboard shortcuts',
  'user.logout': 'Sign out',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'theme.system': 'System',
  'live.on': 'Live updates',
  'live.connecting': 'Connecting…',
  'live.off': 'Offline',
  'shortcuts.title': 'Keyboard shortcuts',
  'shortcuts.palette': 'Search and commands',
  'shortcuts.search': 'Quick search',
  'shortcuts.newTask': 'New task',
  'shortcuts.sidebar': 'Collapse sidebar',
  'shortcuts.help': 'Help for this page (also F1)',
  'shortcuts.jk': 'Next / previous (queue)',
  'shortcuts.yn': 'Confirm / reject link',
  'notifications.title': 'Notifications',
  'notifications.titleUnread': 'Notifications, {n} unread',
  'notifications.empty': 'No new notifications',
  'notifications.markAll': 'Mark all read',
  'notifications.unread': 'unread',
  'notifications.urgent': 'urgent',

  'table.columns': 'Columns',
  'table.empty': 'No rows',
  'table.page': 'Page {page} of {pages}',
  'table.prev': 'Previous page',
  'table.next': 'Next page',
  'calendar.prev': 'Previous',
  'calendar.next': 'Next',
  'calendar.today': 'Today',
  'calendar.kyiv': 'Times in Kyiv',
  'calendar.noDue': 'no due date: {n}',
  'calendar.more': '{n} more',
  'calendar.addOn': 'Add task on {day}',

  'tasks.subtitle': 'Team assignments: list, board, calendar and recurring tasks',
  'tasks.new': 'New task',
  'tasks.create': 'Create',
  'tasks.created': 'Task created',
  'tasks.saved': 'Changes saved',
  'tasks.edit': 'Edit task',
  'tasks.detail': 'Task',
  'tasks.views': 'View',
  'tasks.view.list': 'List',
  'tasks.view.board': 'Board',
  'tasks.view.calendar': 'Calendar',
  'tasks.view.series': 'Recurring',
  'tasks.search': 'Search tasks',
  'tasks.mine': 'Mine',
  'tasks.overdueFilter': 'Overdue',
  'tasks.filter.open': 'Open',
  'tasks.filter.all': 'All statuses',
  'tasks.status.todo': 'To do',
  'tasks.status.in_progress': 'In progress',
  'tasks.status.review': 'In review',
  'tasks.status.done': 'Done',
  'tasks.status.cancelled': 'Cancelled',
  'tasks.priority.low': 'Low',
  'tasks.priority.medium': 'Medium',
  'tasks.priority.high': 'High',
  'tasks.priority.critical': 'Critical',
  'tasks.field.title': 'Title',
  'tasks.field.description': 'Description',
  'tasks.field.priority': 'Priority',
  'tasks.field.status': 'Status',
  'tasks.field.assignee': 'Assignee',
  'tasks.field.due': 'Due',
  'tasks.field.visibility': 'Visibility',
  'tasks.field.link': 'Link to',
  'tasks.field.linkId': 'Object ID',
  'tasks.field.watchers': 'Watchers',
  'tasks.field.creator': 'Creator',
  'tasks.titlePlaceholder': 'E.g. call back Barsik’s owner',
  'tasks.visibility.team': 'Team',
  'tasks.visibility.private': 'Only me',
  'tasks.unassigned': 'Unassigned',
  'tasks.kyivTime': 'Kyiv time',
  'tasks.overdue': 'Overdue',
  'tasks.recurring': 'Recurring',
  'tasks.system': 'System',
  'tasks.updated': 'Updated',
  'tasks.created_at': 'Created',
  'tasks.completed_at': 'Completed',
  'tasks.watch': 'Watch',
  'tasks.unwatch': 'Unwatch',
  'tasks.watched': 'You are watching this task',
  'tasks.unwatched': 'You no longer watch this task',
  'tasks.watchersCount': '{n} people',
  'tasks.occurrences': 'Other occurrences',
  'tasks.comments': 'Comments',
  'tasks.addComment': 'New comment',
  'tasks.commentPlaceholder': 'Write a comment…',
  'tasks.commentHint': 'Ctrl/⌘ + Enter to send',
  'tasks.send': 'Send',
  'tasks.deleteTitle': 'Delete task permanently?',
  'tasks.deleteText': '“{title}” and its comments will be deleted. This cannot be undone.',
  'tasks.deleteConfirm': 'Delete task',
  'tasks.deleted': 'Task deleted',
  'tasks.emptyTitle': 'No tasks',
  'tasks.emptyText': 'All done, or the filter is too narrow.',
  'board.moved': '“{title}” moved to {status}',
  'board.keyboardHelp': 'Enter opens; left/right arrows move to the neighbouring column. With a mouse, drag the card.',
  'board.addTo': 'Add to “{status}”',
  'entity.client': 'Client',
  'entity.pet': 'Pet',
  'entity.visit': 'Visit',
  'entity.journey': 'Visit journey',
  'entity.call': 'Call',
  'entity.rating': 'Rating',
  'entity.insight': 'Insight',

  'series.new': 'Recurring task',
  'series.create': 'Create series',
  'series.created': 'Series created',
  'series.description': 'The task is created automatically on schedule (Kyiv time, DST-aware).',
  'series.every': 'Every',
  'series.everyN': '{n}|{n}|{n}',
  'series.unit': 'Unit',
  'series.unit.minutes': 'Minutes',
  'series.unit.hours': 'Hours',
  'series.unit.days': 'Days',
  'series.unit.weeks': 'Weeks',
  'series.unit.months': 'Months',
  'series.unit.years': 'Years',
  'series.summary': 'Repeats every {every} ({unit})',
  'series.startsAt': 'First occurrence',
  'series.endsAt': 'Ends',
  'series.endsHint': 'Empty — never',
  'series.endsBeforeStart': 'End is before start',
  'series.requirePrevious': 'Only after the previous one is done',
  'series.requirePreviousHint': 'The next task appears only when the previous one is marked done.',
  'series.requirePreviousShort': 'after the previous is done',
  'series.repeat': 'Repeat',
  'series.instances': 'Created',
  'series.active': 'Active',
  'series.stopped': 'Stopped',
  'series.stop': 'Stop',
  'series.stopTitle': 'Stop the series?',
  'series.stopText': 'No new “{title}” tasks will be created. Existing ones stay.',
  'series.stopConfirm': 'Stop series',
  'series.stoppedToast': 'Series stopped',
  'series.emptyTitle': 'No recurring tasks yet',
  'series.emptyText': 'For example: check vaccine stock every Monday.',

  'users.subtitle': 'Staff invitations, roles and access',
  'users.invite': 'Invite',
  'users.inviteTitle': 'Invite a staff member',
  'users.inviteText': 'They get a one-time link (valid 72 hours) to set a password.',
  'users.sendInvite': 'Create invitation',
  'users.fullName': 'Full name',
  'users.name': 'Staff member',
  'users.roles': 'Roles',
  'users.status': 'Status',
  'users.status.active': 'Active',
  'users.status.invited': 'Invited',
  'users.status.disabled': 'Disabled',
  'users.mfaOn': '2FA on',
  'users.mfaOff': 'No 2FA',
  'users.lastLogin': 'Last sign-in',
  'users.never': 'Never',
  'users.search': 'Search by name or email',
  'users.actionsFor': 'Actions for {name}',
  'users.employee': 'Enote employee',
  'users.doctor': 'Doctor',
  'users.notLinked': 'Not linked',
  'users.linkEmployee': 'Link Enote employee…',
  'users.changeEmployee': 'Change Enote employee…',
  'users.employeeTitle': 'Enote employee for {name}',
  'users.employeeText': 'Doctor scoping follows this link: own visits and room transcripts, “my” queues, lab reviews and the pre-visit brief.',
  'users.employeeSearch': 'Search employees',
  'users.employeeNone': 'No employees match',
  'users.employeeLinkedTo': 'Linked to {name}',
  'users.unlinkEmployee': 'Unlink',
  'users.employeeLinked': 'Employee linked',
  'users.employeeUnlinked': 'Employee unlinked',
  'users.employeeTaken': 'This account is already linked to another employee.',
  'users.editRoles': 'Edit roles',
  'users.reinvite': 'New invitation',
  'users.resetMfa': 'Reset 2FA',
  'users.disable': 'Disable',
  'users.enable': 'Enable',
  'users.enabled': 'Account enabled',
  'users.disabled': 'Account disabled',
  'users.mfaReset': 'Two-factor authentication reset',
  'users.disableTitle': 'Disable {name}?',
  'users.disableText': 'All sessions and tokens of the user will be revoked. You can enable the account again at any time.',
  'users.resetMfaTitle': 'Reset two-factor authentication?',
  'users.resetMfaText': '{name} will sign in with a password only and must set up 2FA again.',
  'users.pickRole': 'Pick at least one role',
  'users.linkTitle': 'Invitation created',
  'users.linkText': 'Send this link to {email}. It is valid for 72 hours and works once.',
  'users.linkHint': 'The link is shown only now — copy it.',
  'users.rolesTitle': 'Roles: {name}',
  'users.rolesSaved': 'Roles saved',
  'users.lastAdminTitle': 'Last super admin',
  'role.super_admin': 'Super admin',
  'role.founder': 'Founder',
  'role.admin': 'Administrator',
  'role.doctor': 'Doctor',
  'role.assistant': 'Assistant',
  'role.quality': 'Quality',
  'role.marketing': 'Marketing',
  'role.integrator': 'Integrator',
  'role.super_admin.desc': 'Everything incl. users, secrets and audit',
  'role.founder.desc': 'Read everything, finance and reports',
  'role.admin.desc': 'Schedule, clients, visits, messaging',
  'role.doctor.desc': 'Patients, AI recommendations, approvals',
  'role.assistant.desc': 'View visits and pets, diary',
  'role.quality.desc': 'Calls, ratings, complaints',
  'role.marketing.desc': 'Segments and campaigns, no transcripts',
  'role.integrator.desc': 'Connectors, sync, logs',
  'role.call_center': 'Call-centre operator',
  'role.call_center.desc': 'Clients, calls, bookings, chats, tasks — no finance',
  'users.access': 'Access',
  'users.accessTitle': 'Access: {name}',
  'users.accessText': 'Roles are ready-made sets of permissions. On top of them you can allow or deny any permission for this employee only.',
  'users.accessRoles': 'Roles',
  'users.accessPerms': 'Permissions',
  'users.accessHint': 'Quick start — call-centre operator: role “Call-centre operator” (no finance, no exam-room recordings).',
  'users.accessPreset': 'Apply',
  'users.accessPresetCallCenter': 'Call-centre operator',
  'users.accessPresetNoFinance': 'No finance',
  'users.accessInherit': 'By role',
  'users.accessGrant': 'Allowed',
  'users.accessDeny': 'Denied',
  'users.accessFromRoleOn': 'role gives it',
  'users.accessFromRoleOff': 'role does not',
  'users.accessReset': 'Reset to roles',
  'users.accessEffective': 'In effect: {n} permissions',
  'users.accessEffectiveOn': 'On',
  'users.accessEffectiveOff': 'Off',
  'users.accessSensitive': 'Sensitive',
  'users.accessPrivileged': 'Only a super admin can allow this',
  'users.accessSaved': 'Access saved',
  'users.accessSuperAdmin': 'A super admin always holds every permission — individual settings are not available.',
  'users.accessSelf': 'You cannot change your own access — ask another administrator.',
  'users.accessOverrides': 'Custom access',
  'users.accessOverridesN': 'Custom permissions: {n}',
  'users.accessChanges': 'Permission changes: {n}',
  'journey.statCompleted': 'Completed',
  'permGroup.clients': 'Clients & schedule',
  'permGroup.calls': 'Calls',
  'permGroup.visits': 'Visits & journeys',
  'permGroup.clinical': 'Clinical & AI',
  'permGroup.finance': 'Finance',
  'permGroup.tasks': 'Tasks & inbox',
  'permGroup.marketing': 'Marketing & analytics',
  'permGroup.inventory': 'Inventory',
  'permGroup.admin': 'Administration',
  'perm.clients.read': 'Client, pet and visit records, schedule',
  'perm.clients.contact': 'Full phone numbers and messaging clients',
  'perm.booking.manage': 'Booking requests from the app',
  'perm.diary.write': 'Pet diary',
  'perm.transcripts.call.read': 'Call recordings and transcripts',
  'perm.quality.manage': 'Low-rating follow-ups',
  'perm.visits.journey.read': 'Visit journeys',
  'perm.links.correct': 'Correct journey links',
  'perm.transcripts.room.read': 'Exam-room recordings (own visits)',
  'perm.transcripts.room.read_all': 'Exam-room recordings (all visits)',
  'perm.ai.recommendation.generate': 'AI recommendation drafts',
  'perm.ai.recommendation.approve': 'Approve recommendations and lab results',
  'perm.payments.read': 'Amounts, payments, balances, receipts',
  'perm.finance.dashboard': 'Revenue and finance reports',
  'perm.finance.configure': 'FOP configuration',
  'perm.tasks.manage': 'Tasks',
  'perm.inbox.manage': 'Client chats',
  'perm.marketing.manage': 'Segments and campaigns',
  'perm.marketing.export': 'Contact export',
  'perm.analytics.read': 'Analytics, KPIs, insights',
  'perm.inventory.read': 'Inventory and stock',
  'perm.inventory.manage': 'Inventory: thresholds and warehouse kinds',
  'perm.users.manage': 'Users and access',
  'perm.settings.manage': 'System settings',
  'perm.connectors.configure': 'Connectors and secrets',
  'perm.sync.run': 'Run sync',
  'perm.sync.view': 'Sync status',
  'perm.audit.read': 'Audit log',
  'perm.mcp.tokens.manage': 'API/MCP tokens',

  'connectors.subtitle': 'External systems: health, settings and connection tests',
  'connectors.emptyTitle': 'No connectors yet',
  'connectors.emptyText': 'Integration modules (Enote, AI SIP, cameras, Telegram…) are not registered on the server yet.',
  'connectors.lastSuccess': 'Last success',
  'connectors.failures': 'Failures in a row',
  'connectors.secrets': 'Secrets',
  'connectors.rotated': 'Secrets rotated',
  'connectors.detail': 'Details',
  'connectors.configure': 'Configure',
  'connectors.configureTitle': 'Settings: {name}',
  'connectors.configureText': 'Secrets are stored encrypted and never shown again.',
  'connectors.test': 'Test',
  'connectors.testOk': 'Connection works',
  'connectors.testFail': 'Test failed — see the steps',
  'connectors.lastTest': 'Last test',
  'connectors.noSteps': 'No test steps',
  'connectors.enabledLabel': 'Enabled',
  'connectors.enabledHint': 'A disabled connector does not sync or send messages.',
  'connectors.enabled': 'Connector enabled',
  'connectors.disabled': 'Connector disabled',
  'connectors.saved': 'Settings saved',
  'connectors.secretSet': 'set',
  'connectors.secretNotSet': 'not set',
  'connectors.secretKeepHint': 'Leave empty to keep the current value',
  'connectors.clear': 'Clear',
  'connectors.keep': 'Keep',
  'connectors.noFields': 'This connector has no settings.',
  'health.ok': 'Healthy',
  'health.degraded': 'Degraded',
  'health.down': 'Down',
  'health.auth_error': 'Auth error',
  'health.disabled': 'Disabled',
  'health.unknown': 'Unknown',

  'sync.subtitle': 'Incremental entity sync, run history and error queue',
  'sync.entities': 'Entities',
  'sync.runs': 'Runs',
  'sync.errors': 'Errors',
  'sync.entity': 'Entity',
  'sync.enabled': 'On',
  'sync.enabledFor': 'Sync {entity}',
  'sync.interval': 'Interval',
  'sync.intervalMinutes': 'Interval, minutes',
  'sync.editInterval': 'Edit interval',
  'sync.min': 'min',
  'sync.lastRun': 'Last run',
  'sync.lag': 'Lag',
  'sync.counters': 'Counters',
  'sync.lastError': 'Error',
  'sync.runNow': 'Run now',
  'sync.runAll': 'Run all',
  'sync.full': 'Full',
  'sync.fullHint': 'Reload the whole history (may take hours)',
  'sync.fullTitle': 'Full resync of “{entity}”?',
  'sync.fullText': 'The whole history will be reloaded. This may take hours and load the external system.',
  'sync.fullConfirm': 'Run full resync',
  'sync.reconcile': 'Reconcile',
  'sync.enqueued': '“{entity}” run enqueued',
  'sync.enqueuedMany': 'Enqueued: {n}',
  'sync.emptyTitle': 'No syncable entities',
  'sync.emptyText': 'They appear once integration modules are connected.',
  'sync.noRuns': 'No runs yet',
  'sync.started': 'Started',
  'sync.mode': 'Mode',
  'sync.duration': 'Duration',
  'sync.noErrors': 'No errors',
  'sync.noErrorsText': 'All records synced without problems.',
  'sync.when': 'When',
  'sync.record': 'Record',
  'sync.message': 'Message',
  'sync.retries': 'Retries',
  'sync.retry': 'Retry',
  'sync.retried': 'Retry scheduled',
  'sync.deadLetter': 'Dead-letter',
  'sync.deadLettered': 'Record moved to dead-letter',

  'jobs.subtitle': 'Background job queues (refreshes every 10 s)',
  'jobs.kind': 'Kind',
  'jobs.available': 'Queued',
  'jobs.running': 'Running',
  'jobs.failed': 'Failed',
  'jobs.failedHint': 'Needs attention',
  'jobs.completed': 'Completed 24 h',
  'jobs.empty': 'No background jobs yet',
  'settings.subtitle': 'Product settings as JSON: rules, reminders, quiet hours, AI settings',
  'settings.add': 'New setting',
  'settings.empty': 'No settings yet',
  'settings.emptyText': 'Add the first one — for example quiet hours for notifications.',
  'settings.search': 'Filter by key',
  'settings.unsaved': 'unsaved',
  'settings.revert': 'Revert',
  'settings.saved': 'Setting {key} saved',
  'settings.invalidJson': 'Invalid JSON',
  'settings.key': 'Key',
  'settings.keyInvalid': 'Latin letters, digits, dot, dash and underscore only',
  'settings.value': 'Value (JSON)',
  'audit.subtitle': 'Append-only log: who did what and when',
  'audit.filters': 'Audit filters',
  'audit.action': 'Action (prefix)',
  'audit.actor': 'Actor',
  'audit.entity': 'Entity',
  'audit.entityId': 'Entity ID',
  'audit.when': 'When',
  'audit.via': 'Via',
  'audit.result': 'Result',
  'audit.details': 'Details',
  'audit.empty': 'No entries found',
  'audit.more': 'Loading…',
  'audit.end': 'End of log · {n} entries',
  'system.subtitle': 'Connectors, sync lag and job queues',
  'system.dbOk': 'Database reachable',
  'system.dbDown': 'Database unreachable',
  'system.connectors': 'Connectors',
  'system.sync': 'Sync',
  'system.jobs': 'Background jobs',
  'system.needAttention': 'Need attention: {n}',
  'system.allHealthy': 'All healthy',
  'system.lagging': 'Lagging: {n}',
  'system.syncOk': 'No lag',
  'system.jobsFailed': 'Failed: {n}',
  'system.jobsOk': 'No failures',
  'system.syncLag': 'Sync lag',

  'rooms.subtitle': 'Dovira Cameras, their rooms and exam-room sessions',
  'rooms.empty': 'No rooms yet',
  'rooms.emptyText': 'Rooms appear after syncing with Enote.',
  'rooms.mapped': 'Camera mapped',
  'rooms.unmapped': 'No camera',
  'rooms.noCamera': 'No camera mapped to “{room}” — map it',
  'rooms.noThumb': 'No frame',
  'rooms.thumbAlt': 'Latest camera frame in room {room}',
  'rooms.now': 'now',
  'rooms.map': 'Map camera',
  'rooms.unmap': 'Unmap',
  'rooms.mapTitle': 'Camera for “{room}”',
  'rooms.camera': 'Camera',
  'rooms.noCameras': 'No cameras',
  'rooms.validFrom': 'Valid from',
  'rooms.validTo': 'Valid to',
  'rooms.validToHint': 'Empty — open-ended',
  'rooms.mappedToast': 'Camera mapped',
  'operators.subtitle': 'AI SIP operators ↔ Enote employees ↔ Bridge users',
  'operators.search': 'Search operator',
  'operators.unmapped': 'Without employee: {n}',
  'operators.empty': 'No operators found',
  'operators.operator': 'AI SIP operator',
  'operators.employee': 'Enote employee',
  'operators.user': 'Bridge user',
  'operators.employeeFor': 'Employee for {name}',
  'operators.userFor': 'User for {name}',
  'operators.saved': 'Mapping saved',
  'clientapp.subtitle': 'Booking requests and client app accounts',
  'clientapp.requests': 'Booking requests',
  'clientapp.accounts': 'Accounts',
  'clientapp.noRequests': 'No new requests',
  'clientapp.wants': 'Preferred: {when}',
  'clientapp.anyTime': 'Any time',
  'clientapp.confirm': 'Confirm',
  'clientapp.reject': 'Reject',
  'clientapp.confirmTitle': 'Confirm booking: {name}',
  'clientapp.confirmText': 'The appointment is created in Enote and the client is notified.',
  'clientapp.confirmed': 'Booking confirmed',
  'clientapp.rejectTitle': 'Reject request',
  'clientapp.rejected': 'Request rejected',
  'clientapp.reason': 'Reason',
  'clientapp.reasonHint': 'The client will see this text',
  'clientapp.time': 'Visit time',
  'clientapp.searchAccounts': 'Search by phone or name',
  'clientapp.typeToSearch': 'Type at least 2 characters',
  'clientapp.account': 'Account',
  'clientapp.client': 'Client',
  'clientapp.platform': 'Platform',
  'clientapp.lastSeen': 'Last seen',
  'clientapp.verified': 'verified',

  'profile.subtitle': 'Personal info, security, access tokens and notifications',
  'profile.tab.me': 'About me',
  'profile.tab.security': 'Security',
  'profile.tab.tokens': 'API & MCP',
  'profile.tab.notifications': 'Notifications',
  'profile.mfa': 'Two-factor authentication',
  'profile.permissions': 'Permissions',
  'profile.changePassword': 'Change password',
  'profile.changePasswordText': 'Other sessions stay active — revoke them below if needed.',
  'profile.currentPassword': 'Current password',
  'profile.newPassword': 'New password',
  'profile.passwordChanged': 'Password changed',
  'profile.passwordSame': 'The new password must differ from the current one',
  'profile.totp': 'Two-factor authentication',
  'profile.totpText': 'A code from your app (Google Authenticator, 1Password, Authy) at every sign-in.',
  'profile.totpStart': 'Set up 2FA',
  'profile.totpRestart': 'Re-issue key',
  'profile.totpReconfigure': '2FA is on. You can re-issue the key, e.g. for a new phone.',
  'profile.totpStep1': 'Scan the QR code with your authenticator app or enter the key manually.',
  'profile.totpStep2': 'Enter the 6-digit code to confirm.',
  'profile.totpConfirm': 'Turn on 2FA',
  'profile.totpEnabled': 'Two-factor authentication is on',
  'profile.qrAlt': 'QR code for the authenticator app',
  'profile.sessions': 'Active sessions',
  'profile.sessionsText': 'Devices signed in to your account.',
  'profile.thisDevice': 'this device',
  'profile.lastSeen': 'active {when}',
  'profile.expires': 'valid until {when}',
  'profile.revoke': 'Revoke',
  'profile.sessionRevoked': 'Session revoked',
  'tokens.title': 'API & MCP tokens',
  'tokens.text': 'For Claude (Desktop, Code, claude.ai) and scripts. A token acts with your permissions or narrower.',
  'tokens.create': 'Create token',
  'tokens.createText': 'Choose a name, expiry and the tools the token may use.',
  'tokens.empty': 'No tokens yet',
  'tokens.emptyText': 'Create a token to connect Claude to the Bridge over MCP.',
  'tokens.name': 'Name',
  'tokens.nameHint': 'E.g. “Claude Desktop — laptop”',
  'tokens.ttl': 'Expiry',
  'tokens.days': '{n} days',
  'tokens.noExpiry': 'Never expires',
  'tokens.tools': 'Allowed tools',
  'tokens.filterTools': 'Filter tools',
  'tokens.readOnly': 'Read-only',
  'tokens.allTools': 'All tools',
  'tokens.allToolsHint': 'Nothing selected — the token gets every tool your role may call.',
  'tokens.selectedN': 'Tools selected: {n}',
  'tokens.toolsN': '{n} tools',
  'tokens.used': 'used {when}',
  'tokens.neverUsed': 'never used',
  'tokens.expires': 'valid until {when}',
  'tokens.revoke': 'Revoke token',
  'tokens.revokeTitle': 'Revoke “{name}”?',
  'tokens.revokeText': 'Every client using this token loses access immediately.',
  'tokens.revoked': 'Token revoked',
  'tokens.createdTitle': 'Token “{name}” created',
  'tokens.onceWarning': 'Copy the token now — it will not be shown again.',
  'tokens.savedIt': 'I saved the token',
  'tokens.howTo': 'How to connect',
  'tokens.howCode': 'Run in a terminal:',
  'tokens.howDesktop': 'Add to claude_desktop_config.json and restart Claude Desktop:',
  'tokens.howWeb': 'In claude.ai → Settings → Connectors add a custom connector with this URL (OAuth sign-in, no token needed):',
  'tokens.howStdio': 'Locally on the server (stdio):',
  'prefs.title': 'Task notifications',
  'prefs.text': 'When and where to notify you.',
  'prefs.assign': 'A task is assigned to me',
  'prefs.assignHint': 'Right after assignment',
  'prefs.comment': 'A comment on my task',
  'prefs.commentHint': 'If I am the assignee or a watcher',
  'prefs.creatorComment': 'A comment on a task I created',
  'prefs.creatorCommentHint': 'If I am the creator',
  'prefs.due': 'Due reminder',
  'prefs.dueHint': 'Once before the due time',
  'prefs.leadHours': 'Remind this many hours before',
  'prefs.leadHoursHint': '1 to 168 hours',
  'prefs.leadHoursErr': 'Enter 1 to 168',
  'prefs.channels': 'Channels',
  'prefs.ch.inbox': 'In-app',
  'prefs.ch.telegram': 'Telegram',
  'prefs.ch.email': 'Email',
  'prefs.ch.push': 'Push',
  'prefs.saved': 'Notification settings saved',
  'prefs.telegramText': 'Get notifications from the clinic Telegram bot.',
  'prefs.pairTelegram': 'Connect Telegram',
  'prefs.openTelegram': 'Open Telegram',
  'prefs.telegramHint': 'Press “Start” in the bot to finish pairing. The link is valid for 10 minutes.',

  'today.night': 'Good night',
  'today.morning': 'Good morning',
  'today.afternoon': 'Good afternoon',
  'today.evening': 'Good evening',
  'today.dashboard': 'Dashboard',
  'today.variant.admin': 'Administrator',
  'today.variant.doctor': 'Doctor',
  'today.variant.founder': 'Founder',
  'today.appointments': 'Today’s appointments',
  'today.noAppointments': 'No appointments today',
  'today.late': 'Running late',
  'today.noLate': 'Everyone is on time',
  'today.unbooked': 'Calls without booking (24 h)',
  'today.noUnbooked': 'Everyone who called is booked',
  'today.callback': 'Call back',
  'today.callbackTitle': 'Call back: {who}',
  'today.callbackCreated': '“Call back” task created',
  'today.labsUndelivered': 'Labs awaiting review',
  'today.labsReview': 'Labs to review',
  'today.noLabs': 'No new results',
  'today.abnormal': 'out of range: {n}',
  'today.lowRatings': 'Low ratings',
  'today.noFollowups': 'No unhappy clients',
  'today.unpaid': 'Yesterday: unpaid / no receipt',
  'today.noFlags': 'No discrepancies',
  'today.bookingRequests': 'Booking requests',
  'today.myTasks': 'My tasks',
  'today.noTasks': 'No open tasks',
  'today.nextPatients': 'Next patients',
  'today.noPatients': 'No patients today',
  'today.drafts': 'Drafts awaiting approval',
  'today.noDrafts': 'All recommendations approved',
  'today.oldestDraft': 'Oldest: {when}',
  'today.period': 'Period',
  'today.vsPrev': 'vs prev.',
  'today.noCompare': 'no comparison',
  'period.today': 'Today',
  'period.week': 'Week',
  'period.month': 'Month',
  'kpi.revenue': 'Revenue',
  'kpi.visits': 'Visits',
  'kpi.avgCheck': 'Average check',
  'kpi.newClients': 'New clients',
  'kpi.noShow': 'No-shows',
  'kpi.conversion': 'Booking conversion',
  'kpi.revenueTrend': 'Revenue by day',
  'kpi.current': 'Current period',
  'kpi.previous': 'Previous period',
  'kpi.byFop': 'Revenue by FOP',
  'kpi.funnel': 'Conversion',
  'kpi.calls': 'Calls',
  'kpi.bookings': 'Bookings',
  'kpi.visitsDone': 'Visits',
  'kpi.doctorLoad': 'Doctor load',
  'appt.booked': 'Booked',
  'appt.confirmed': 'Confirmed',
  'appt.arrived': 'Arrived',
  'appt.in_room': 'In room',
  'appt.done': 'Done',
  'appt.no_show': 'No-show',
  'appt.cancelled': 'Cancelled',

  'schedule.date': 'Date',
  'schedule.day': 'Day',
  'schedule.week': 'Week',
  'schedule.byDoctor': 'By doctor',
  'schedule.byRoom': 'By room',
  'schedule.empty': 'No appointments in this period',
  'schedule.unassigned': 'Unassigned',
  'schedule.client': 'Client',
  'schedule.pet': 'Pet',
  'schedule.doctor': 'Doctor',
  'schedule.room': 'Room',
  'schedule.time': 'Time',
  'schedule.reason': 'Reason',
  'schedule.openJourney': 'Open visit',

  'journey.subtitle': 'Every visit’s journey: call → booking → room → treatment → payment → recommendations → rating',
  'journey.search': 'Search by pet or client',
  'journey.missingLinks': 'Missing links',
  'journey.visit': 'Visit',
  'journey.patient': 'Patient',
  'journey.stages': 'Stages',
  'journey.flags': 'Flags',
  'journey.rating': 'Rating',
  'journey.pendingLinks': 'to review: {n}',
  'journey.timeline': 'Timeline',
  'journey.context': 'Client & pet',
  'journey.date': 'Date',
  'journey.generate': 'Generate recommendations',
  'journey.draftRequested': 'Draft generation started',
  'journey.message': 'Message client',
  'journey.createTask': 'Create task',
  'stage.call': 'Call',
  'stage.booking': 'Booking',
  'stage.arrival': 'Arrival',
  'stage.room': 'Room',
  'stage.clinical': 'Clinical',
  'stage.invoice': 'Invoice',
  'stage.payment': 'Payment',
  'stage.recommendations': 'Recommendations',
  'stage.rating': 'Rating',
  'stage.followup': 'Follow-up',
  'stage.state.ok': 'done',
  'stage.state.warn': 'needs attention',
  'stage.state.none': 'no data',
  'stage.state.na': 'not applicable',
  'link.auto': 'auto',
  'link.proposed': 'proposed',
  'link.manual': 'manual',
  'link.confirmed': 'confirmed',
  'link.rejected': 'rejected',
  'link.confirm': 'Confirm',
  'link.reject': 'Reject',
  'link.replace': 'Replace',
  'link.confirmedToast': 'Link confirmed',
  'link.rejectedToast': 'Link rejected',
  'link.replacedToast': 'Link replaced',
  'link.replaceTitle': 'Replace link',
  'link.replaceText': 'Enter the correct object ({kind}).',
  'link.targetId': 'Object ID',
  'link.targetHint': 'Copy the call or session ID from its page',
  'review.subtitle': 'Proposed links ordered by visit time.',
  'review.nav': 'navigate',
  'review.queue': 'Link queue',
  'review.empty': 'The queue is empty',
  'review.emptyText': 'All proposed links are reviewed.',
  'review.kind.call': 'Call',
  'review.kind.room': 'Room session',
  'review.proposed': 'Proposed',
  'review.alternative': 'Alternative',
  'review.useThis': 'Use this one',
  'review.evidence': 'Evidence',
  'review.excerpt': 'Transcript excerpt',
  'review.split': 'Split session',
  'review.splitText': 'If the recording holds two visits back to back, drag the boundary to where the patient changes.',
  'review.splitAt': 'Boundary',
  'review.splitButton': 'Split',
  'review.splitDone': 'Session split',

  'clients.subtitle': 'All clinic clients; search by name, phone or pet',
  'clients.searchPlaceholder': 'Name, phone or pet…',
  'clients.hintTitle': 'Who are we looking for?',
  'clients.hintText': 'Try part of a name, phone or pet name.',
  'clients.lastVisit': 'Last visit: {date}',
  'clients.lastVisitLabel': 'Last visit',
  'clients.app': 'App',
  'clients.phones': 'Phones',
  'clients.balance': 'Balance',
  'clients.visits': 'Visits',
  'clients.since': 'Client since',
  'clients.pets': 'Pets',
  'clients.deceased': 'deceased',
  'timeline.empty': 'No events yet',
  'pet.species': 'Species / breed',
  'pet.sex': 'Sex',
  'pet.age': 'Age',
  'pet.ageValue': '{y} y {m} m',
  'pet.birth': 'Date of birth',
  'pet.weight': 'Weight',
  'pet.chip': 'Microchip',
  'pet.labs': 'Labs',
  'pet.profile': 'Profile',
  'pet.latest': 'Latest values',
  'pet.noLabs': 'No lab results yet',
  'pet.bandHint': 'The green band is the reference range; red points are out of range.',
  'pet.vaccinations': 'Vaccinations',
  'pet.weightTrend': 'Weight trend',
  'lab.normal': 'normal',
  'lab.high': 'above range',
  'lab.low': 'below range',

  'doctor.subtitle': 'My patients, pre-visit briefs and recommendation drafts',
  'doctor.drafts': 'AI drafts',
  'doctor.myVisits': 'My visits today',
  'doctor.briefs': 'Upcoming patients',
  'doctor.allergies': 'Allergies',
  'doctor.phoneNotes': 'Said on the phone',
  'doctor.lastLabs': 'Last labs',
  'draft.transcript': 'Transcript',
  'draft.editor': 'Recommendations for the client',
  'draft.summary': 'Summary for the client',
  'draft.diagnosis': 'Diagnosis',
  'draft.treatment': 'Treatment',
  'draft.recommendations': 'Recommendations',
  'draft.follow_up': 'Follow-up',
  'draft.medications': 'Medications',
  'draft.medName': 'Medication',
  'draft.dose': 'Dose',
  'draft.schedule': 'Schedule',
  'draft.reminder': 'Client reminder',
  'draft.reminderHint': 'The client gets a dose reminder',
  'draft.addMed': 'Add medication',
  'draft.approve': 'Approve & send',
  'draft.approved': 'Recommendations sent to the client',
  'draft.saved': 'Recommendation saved',
  'draft.reject': 'Reject',
  'draft.rejectTitle': 'Reject the recommendation',
  'draft.rejected': 'Recommendation rejected',
  'draft.regenerate': 'Regenerate',
  'draft.regenText': 'Tell the AI what to change.',
  'draft.note': 'Note',
  'draft.noteHint': 'E.g. “shorter, no Latin”',
  'draft.changed': 'sections changed: {n}',
  'draft.edited': 'edited',
  'draft.citations': '{n} sources',
  'draft.createdBy': 'source: {source}',
  'transcript.empty': 'No transcript',
  'transcript.search': 'Search transcript',
  'transcript.matches': '{n} matches',
  'transcript.seek': 'Jump to {t}',
  'transcript.doctor': 'doctor',
  'transcript.client': 'client',
  'transcript.assistant': 'assistant',
  'transcript.operator': 'operator',

  'calls.subtitle': 'AI SIP calls: transcripts, scores, links to visits',
  'calls.when': 'When',
  'calls.who': 'Who',
  'calls.unknown': 'Unknown number',
  'calls.operator': 'Operator',
  'calls.duration': 'Duration',
  'calls.score': 'Score',
  'calls.risk': 'Risk',
  'calls.risk.low': 'low',
  'calls.risk.medium': 'medium',
  'calls.risk.high': 'high',
  'calls.flags': 'Flags',
  'calls.intent': 'Booking intent',
  'calls.linked': 'Linked',
  'calls.unlinked': 'Unlinked',
  'calls.linkedFilter': 'Link',
  'calls.from': 'From',
  'calls.to': 'To',
  'calls.direction': 'Direction',
  'calls.inbound': 'Inbound',
  'calls.outbound': 'Outbound',
  'calls.status': 'Status',
  'calls.answered': 'Answered',
  'calls.missedStatus': 'Missed',
  'calls.search': 'Search by number or name',
  'calls.analysis': 'Call analysis',
  'calls.requiredActions': 'Required actions',
  'calls.links': 'Links',
  'calls.noLinks': 'The call is not linked to a visit yet',
  'missed.subtitle': 'Inbound calls with booking intent and no booking within 24 hours',
  'missed.emptyText': 'No missed opportunities.',
  'missed.intent': 'intent {p}',
  'missed.callbackTask': '“Call back” task',

  'inbox.subtitle': 'Client chat (app and Telegram)',
  'inbox.empty': 'No open conversations',
  'inbox.conversations': 'Conversations',
  'inbox.close': 'Close conversation',
  'inbox.message': 'Message',
  'inbox.placeholder': 'Reply to the client… (Enter to send, Shift+Enter for a new line)',

  'finance.subtitle': 'Payments and receipts reconciliation by FOP, discrepancies and revenue',
  'finance.revenue': 'Revenue by FOP',
  'finance.other': 'Other',
  'finance.reconciliation': 'Reconciliation: day × FOP',
  'finance.date': 'Date',
  'finance.fop': 'FOP',
  'finance.sales': 'Sales',
  'finance.receipts': 'Receipts',
  'finance.discrepancy': 'Discrepancy',
  'finance.flags': 'Flagged visits',
  'finance.flagKind': 'Discrepancy type',
  'finance.amount': 'Amount',
  'finance.expected': 'expected',
  'finance.flag.no_receipt': 'No fiscal receipt',
  'finance.flag.amount_mismatch': 'Receipt amount mismatch',
  'finance.flag.fop_mismatch': 'Receipt on another FOP',
  'finance.flag.unpaid': 'Unpaid',

  'quality.subtitle': 'Visit ratings and follow-up of unhappy clients (30 days)',
  'quality.summary': 'Ratings',
  'quality.avg': 'Average',
  'quality.count': '{n} ratings',
  'quality.distribution': 'Rating distribution',
  'quality.followups': 'Needs a response',
  'quality.resolve': 'Resolve',
  'quality.resolveTitle': 'Response to rating: {name}',
  'quality.resolution': 'What was done',
  'quality.resolutionHint': 'E.g. called, offered a free re-check',
  'quality.resolved': 'Follow-up resolved',

  'marketing.subtitle': 'Client segments and consent-aware campaigns',
  'marketing.segments': 'Segments',
  'marketing.campaigns': 'Campaigns',
  'marketing.newSegment': 'New segment',
  'marketing.editSegment': 'Segment',
  'marketing.noSegments': 'No segments yet',
  'marketing.pickSegment': 'Pick a segment or create a new one',
  'marketing.rulesN': '{n} rules',
  'marketing.liveCount': 'Clients',
  'marketing.segmentName': 'Segment name',
  'marketing.rules': 'Rules',
  'marketing.addRule': 'Add rule',
  'marketing.field': 'Field',
  'marketing.op': 'Operator',
  'marketing.value': 'Value',
  'marketing.saved': 'Segment saved',
  'marketing.f.species': 'Species',
  'marketing.f.age_years': 'Pet age, years',
  'marketing.f.last_visit_days': 'Days since visit',
  'marketing.f.vaccination_due': 'Vaccination',
  'marketing.f.spend_12m': 'Spend, UAH',
  'marketing.f.rating': 'Average rating',
  'marketing.f.channel': 'Channel',
  'marketing.op.eq': 'equals',
  'marketing.op.neq': 'not equals',
  'marketing.op.gte': '≥',
  'marketing.op.lte': '≤',
  'marketing.newCampaign': 'New campaign',
  'marketing.noCampaigns': 'No campaigns yet',
  'marketing.campaign': 'Campaign',
  'marketing.segment': 'Segment',
  'marketing.channel': 'Channel',
  'marketing.scheduled': 'Scheduled',
  'marketing.sent': 'Sent',
  'marketing.delivered': 'Delivered',
  'marketing.bookings': 'Bookings',
  'marketing.text': 'Message text',
  'marketing.textHint': '{n} characters',
  'marketing.scheduleHint': 'Empty — draft',
  'marketing.consentNote': 'Only clients with consent receive it; an opt-out is added automatically.',
  'marketing.create': 'Create campaign',
  'marketing.created': 'Campaign created',

  'insights.subtitle': 'Findings of scheduled Claude analyses — turn them into tasks',
  'insights.new': 'New',
  'insights.converted': 'In tasks',
  'insights.dismissed': 'Dismissed',
  'insights.empty': 'No new insights',
  'insights.emptyText': 'Claude publishes insights after daily and weekly analyses.',
  'insights.toTask': 'Create task',
  'insights.taskCreated': 'Task created',
  'insights.dismiss': 'Dismiss',
  'insights.openTask': 'Open task →',
  'insights.sev.info': 'info',
  'insights.sev.warning': 'warning',
  'insights.sev.critical': 'critical',
  'table.pageN': 'Page {page}',
  'table.pageTotal': 'Page {page} · {total} total',
  'filters.reset': 'Reset',
  'filters.from': 'from',
  'filters.to': 'to',
  'stage.confirmation_call': 'Confirmation',
  'stage.room_session': 'Exam room',
  'stage.diagnoses': 'Diagnoses',
  'stage.labs': 'Labs',
  'stage.prescriptions': 'Prescriptions',
  'stage.vaccinations': 'Vaccinations',
  'stage.sale': 'Invoice',
  'stage.receipt': 'Receipt',
  'stage.recommendation': 'Recommendation',
  'stage.follow_up': 'Follow-up',
  'stage.followup_call': 'Follow-up call',
  'stage.state.present': 'done',
  'stage.state.proposed': 'to review',
  'stage.state.missing': 'missing',
  'stage.state.not_applicable': 'n/a',
  'ev.iou': 'Time overlap (IoU)',
  'ev.pet_mentioned': 'Pet name mentioned',
  'ev.species_mentioned': 'Species mentioned',
  'ev.doctor_mentioned': 'Doctor mentioned',
  'ev.doctor_voice': 'Doctor\'s voice',
  'ev.client_surname': 'Client surname',
  'ev.clinical_mentioned': 'Clinical terms',
  'ev.room_exact': 'Same room',
  'ev.dept_fallback': 'Department only',
  'ev.ambiguity': 'Ambiguity',
  'ev.phone_match': 'Phone match',
  'ev.time_proximity': 'Time proximity',
  'ev.rule': 'Rule',
  'ev.logit': 'Logit',
  'ev.low_signal': 'Low signal',
  'ev.no_auto': 'No auto-confirm',
  'ev.phone_client': 'Client phone',
  'ev.phone_appointment': 'Booking phone',
  'ev.phone_household': 'Household phone',
  'ev.ended_before_created': 'Call right before booking',
  'ev.operator_is_author': 'Operator created booking',
  'ev.booking_intent': 'Booking intent',
  'ev.confirm_window': 'Confirmation window',
  'ev.followup_window': 'Follow-up window',
  'fact.amount': 'Amount',
  'fact.paid_amount': 'Paid',
  'fact.total_amount': 'Total',
  'fact.fop': 'FOP',
  'fact.method': 'Method',
  'fact.number': 'No.',
  'fact.fiscal_number': 'Fiscal no.',
  'fact.status': 'Status',
  'fact.camera': 'Camera',
  'fact.room': 'Room',
  'fact.speech_seconds': 'Speech',
  'fact.low_signal': 'Low signal',
  'fact.confirmed': 'Confirmed',
  'fact.duration_min': 'Duration, min',
  'fact.duration_s': 'Duration',
  'fact.diagnosis': 'Diagnosis',
  'fact.visit_type': 'Visit type',
  'fact.doc_type': 'Document',
  'fact.is_return': 'Refund',
  'fact.direction': 'Direction',
  'fact.operator': 'Operator',
  'fact.score': 'Score',
  'fact.stars': 'Stars',
  'journey.openCall': 'Open call',
  'journey.openTranscript': 'Open transcript',
  'journey.recommendation': 'Recommendation',
  'journey.pendingHint': 'Confirm or reject the proposals in the timeline below.',
  'journey.noTimeline': 'No events yet',
  'journey.planned': 'Planned',
  'journey.started': 'Actual',
  'journey.nextVisit': 'Next visit',
  'journey.links': 'Links',
  'journey.state': 'State',
  'journey.allStates': 'All states',
  'journey.allFlags': 'All flags',
  'journey.oneClient': 'One client',
  'journey.empty': 'No journeys in this period',
  'journey.emptyHint': 'Change the period or filters.',
  'journey.statTotal': 'Journeys',
  'journey.statPaid': 'Paid',
  'journey.statBookingCall': 'Bookings with a call',
  'journey.statRoom': 'Visits with transcript',
  'journey.statMissed': 'Missed opportunities',
  'anchor.appointment': 'booked',
  'anchor.walk_in': 'walk-in',
  'anchor.call_only': 'call only',
  'anchor.visit': 'visit',
  'jstate.planned': 'Planned',
  'jstate.called_not_booked': 'Called, not booked',
  'jstate.booked': 'Booked',
  'jstate.arrived': 'Arrived',
  'jstate.in_room': 'In room',
  'jstate.completed': 'Completed',
  'jstate.paid': 'Paid',
  'jstate.closed': 'Closed',
  'jstate.no_show': 'No-show',
  'jstate.cancelled': 'Cancelled',
  'jflag.missing_recommendation': 'No recommendation',
  'jflag.ai_draft_pending': 'AI draft pending',
  'jflag.unlinked_transcript': 'Transcript not linked',
  'jflag.unlinked_call': 'Call not linked',
  'jflag.unpaid': 'Unpaid',
  'jflag.partially_paid': 'Partially paid',
  'jflag.no_receipt': 'No receipt',
  'jflag.amount_mismatch': 'Amount mismatch',
  'jflag.fop_mismatch': 'FOP mismatch',
  'jflag.low_rating': 'Low rating',
  'review.type': 'Entity type',
  'review.allTypes': 'All types',
  'review.candidates': '{n} candidates',
  'transcript.unknown': 'unknown',
  'transcript.roles': 'Speaker roles',
  'appt.scheduled': 'Scheduled',
  'appt.in_progress': 'In progress',
  'appt.completed': 'Completed',
  'appt.refused': 'Refused',
  'schedule.allDoctors': 'All doctors',
  'schedule.allRooms': 'All rooms',
  'schedule.sumActive': 'Appointments',
  'schedule.sumConfirmed': 'Confirmed',
  'schedule.sumWalkIns': 'Walk-ins',
  'schedule.sumCancelled': 'Cancelled',
  'schedule.sumFlagged': 'Flagged',
  'schedule.walkIn': 'walk-in',
  'schedule.phone': 'Phone',
  'schedule.comment': 'Comment',
  'schedule.number': 'Number',
  'draft.care': 'Care instructions',
  'draft.diet': 'Diet',
  'draft.warning': 'Warning signs',
  'draft.uncertainties': 'Uncertainties (for the doctor)',
  'draft.followType': 'Follow-up type',
  'draft.inDays': 'In days',
  'draft.followReason': 'Follow-up reason',
  'draft.route': 'Route',
  'draft.days': 'Days',
  'draft.notes': 'Notes',
  'draft.withFood': 'with food',
  'draft.fromTranscript': 'from transcript',
  'draft.fromRecord': 'from record',
  'draft.generating': 'AI is drafting…',
  'draft.revoke': 'Revoke',
  'draft.revokeTitle': 'Revoke the recommendation?',
  'draft.revokeText': 'The client will no longer see it in the app.',
  'draft.revoked': 'Recommendation revoked',
  'draft.record': 'Visit record',
  'draft.anamnesis': 'Anamnesis',
  'draft.inRecord': 'Recommendation in Enote',
  'draft.noTranscript': 'No transcript',
  'draft.noTranscriptHint': 'No confirmed room session for this visit yet.',
  'rec.draft': 'draft',
  'rec.published': 'published',
  'rec.rejected': 'rejected',
  'rec.revoked': 'revoked',
  'follow.none': 'None',
  'follow.control_visit': 'Control visit',
  'follow.lab': 'Lab test',
  'follow.vaccination': 'Vaccination',
  'common.add': 'Add',
  'doctor.notMapped': 'Your account is not linked to an Enote employee — ask an admin to map it in Users.',
  'doctor.needRecommendation': 'Visits without recommendation',
  'doctor.allWritten': 'All recommendations written',
  'doctor.makeBrief': 'Prepare brief',
  'calls.allOperators': 'All operators',
  'calls.details': 'Call details',
  'calls.empty': 'No calls in this period',
  'calls.history': 'Analysis history',
  'calls.managerAttention': 'Manager attention',
  'calls.ownerAttention': 'Owner attention',
  'calls.needsAttention': 'Needs attention',
  'calls.noAnalysis': 'No analysis yet',
  'calls.noHits': 'Nothing found in transcripts',
  'calls.routes': 'Routing',
  'calls.searchTranscripts': 'Search transcripts',
  'calls.waiting': 'Waiting',
  'calls.st.answered': 'answered',
  'calls.st.missed': 'missed',
  'calls.st.no_answer': 'no answer',
  'calls.st.busy': 'busy',
  'calls.st.failed': 'failed',
  'clients.blacklisted': 'Blacklisted',
  'clients.unreliable': 'Unreliable',
  'clients.calls': 'Calls',
  'clients.contactPersons': 'Contact persons',
  'clients.curator': 'Curator',
  'clients.messages': '{n} chat messages',
  'clients.name': 'Client',
  'clients.nextAppt': 'Next appointment',
  'clients.primary': ' primary',
  'clients.refreshed': 'Enote refresh queued',
  'common.loadMore': 'Load more',
  'missed.taskCreated': 'Call-back task created',
  'missed.taskExists': 'Task exists',
  'pet.activeRx': 'Active prescriptions',
  'pet.aggressive': 'Aggressive',
  'pet.blood': 'Blood group',
  'pet.diet': 'Diet',
  'pet.doctor': 'Attending doctor',
  'pet.indicators': 'Indicators',
  'pet.labOrders': 'Lab orders',
  'pet.labPending': 'pending',
  'pet.markReviewed': 'Reviewed — release to client',
  'pet.neutered': 'neutered',
  'pet.noValues': 'No results yet',
  'pet.planned': 'planned',
  'pet.reviewed': 'Result released to the client',
  'pet.reviewedBy': 'reviewed by {who}, {date}',
  'pet.trend': 'Trend',
  'session.clips': 'Clips',
  'session.details': 'Session',
  'session.speakers': 'Speakers',
  'session.speech': 'Speech',
  'timeline.kinds': 'Event kinds',
  'tl.appointment': 'Appointments',
  'tl.visit': 'Visits',
  'tl.lab_order': 'Labs',
  'tl.prescription': 'Prescriptions',
  'tl.vaccination': 'Vaccinations',
  'tl.payment': 'Payments',
  'tl.call': 'Calls',
  'tl.rating': 'Ratings',
  'clientapp.channels': 'Channels',
  'clientapp.clientId': 'Bridge client id',
  'clientapp.clientIdHint': 'Copy it from the client card URL (/clients/…)',
  'clientapp.kiosk': 'Rating kiosk',
  'clientapp.kioskDisable': 'Disable kiosk',
  'clientapp.kioskDisableText': 'The reception tablet will stop accepting ratings.',
  'clientapp.kioskEnable': 'Enable and create token',
  'clientapp.kioskNew': 'New token created — enter it on the tablet',
  'clientapp.kioskOff': 'off',
  'clientapp.kioskOn': 'on',
  'clientapp.kioskRegen': 'Regenerate token',
  'clientapp.kioskText': 'A reception tablet collects visit ratings. The old token stops working once a new one is generated.',
  'clientapp.link': 'Link',
  'clientapp.linkTitle': 'Link {name} to a client',
  'clientapp.linked': 'Account linked',
  'clientapp.minutes': 'Minutes',
  'clientapp.relation': 'Relation',
  'clientapp.response': 'Reply to the client',
  'clientapp.revoked': 'revoked',
  'clientapp.st.open': 'Open',
  'clientapp.st.new': 'New',
  'clientapp.st.in_progress': 'In progress',
  'clientapp.st.confirmed': 'Confirmed',
  'clientapp.st.declined': 'Declined',
  'clientapp.st.cancelled': 'Cancelled',
  'clientapp.kind.booking': 'booking',
  'clientapp.kind.cancel': 'cancellation',
  'clientapp.kind.cancellation': 'cancellation',
  'clientapp.kind.new_pet': 'new pet',
  'clientapp.kind.pet_add': 'new pet',
  'clientapp.tod.morning': 'morning',
  'clientapp.tod.afternoon': 'afternoon',
  'clientapp.tod.evening': 'evening',
  'clientapp.rel.owner': 'Owner',
  'clientapp.rel.family': 'Family',
  'clientapp.rel.caretaker': 'Caretaker',
  'clientapp.take': 'Take',
  'clientapp.taken': 'Request taken',
  'clientapp.unlink': 'Unlink',
  'clientapp.unlinkText': 'The app loses access to «{name}».',
  'clientapp.unlinkTitle': 'Unlink the account?',
  'clientapp.unlinked': 'Access revoked',
  'common.saved': 'Saved',
  'doctor.notMappedShort': 'Account not linked to an Enote doctor',
  'finance.actual': 'actual',
  'finance.allFops': 'All FOPs',
  'finance.avgCheck': 'Average check',
  'finance.card': 'Card',
  'finance.cash': 'Cash',
  'finance.displayName': 'Display name',
  'finance.docs': '{n} documents',
  'finance.exported': '{n} rows exported',
  'finance.fiscalExpected': 'To fiscalise',
  'finance.flagsN': '{n} flags',
  'finance.fops': 'FOPs',
  'finance.gap': 'Unfiscalised',
  'finance.group.day': 'Day',
  'finance.group.org': 'FOP',
  'finance.group.department': 'Department',
  'finance.group.doctor': 'Doctor',
  'finance.group.service_group': 'Service group',
  'finance.groupBy': 'Group by',
  'finance.last30': 'Last 30 days: {n} payments, {sum}',
  'finance.method': 'Method',
  'finance.m.cash': 'cash',
  'finance.m.card': 'card',
  'finance.m.mixed': 'mixed',
  'finance.m.bonus': 'bonus',
  'finance.m.other': 'other',
  'finance.net': 'Net',
  'finance.netByDay': 'Net by day',
  'finance.noFop': 'No FOP',
  'finance.notFop': 'not FOP',
  'finance.paid': 'Paid',
  'finance.payments': 'Payments',
  'finance.paymentsSummary': '{n} payments, {total}; refunds {refunds}',
  'finance.prevPeriod': 'Previous period',
  'finance.receiptFop': 'Receipt FOP',
  'finance.refunds': 'Refunds',
  'finance.salesCount': 'Sales',
  'finance.share': 'Share',
  'finance.taxGroup': 'Tax group',
  'finance.total': 'Total',
  'finance.vsPrev': 'vs previous',
  'finance.flag.partially_paid': 'Partially paid',
  'finance.flag.fop_unknown': 'FOP unknown',
  'insights.acknowledge': 'Acknowledge',
  'insights.acknowledged': 'acknowledged',
  'insights.severity': 'Severity',
  'kpi.labTurnaround': 'Lab turnaround median',
  'kpi.vaccCompliance': 'vaccinations on time',
  'kpi.answered': 'Answered',
  'kpi.intent': 'With booking intent',
  'quality.allScores': 'All scores',
  'quality.byMonth': 'Month',
  'quality.comment': 'Comment',
  'quality.five': 'Five-star',
  'quality.low': 'Low ratings',
  'quality.ratings': 'Ratings',
  'quality.source': 'Source',
  'quality.tags': 'Tags',
  'quality.fs.open': 'Open',
  'quality.fs.overdue': 'Overdue',
  'quality.fs.resolved': 'Resolved',
  'today.noUpcoming': 'No more appointments today',
  'marketing.noSegmentsHint': 'Create a segment — the client count updates live.',
  'marketing.accounts': '{n} app accounts',
  'marketing.description': 'Description',
  'marketing.f.lastVisitAfter': 'Last visit after',
  'marketing.f.lastVisitBefore': 'Last visit before',
  'marketing.f.noVisitMonths': 'No visit for, months',
  'marketing.f.hasApp': 'Has app',
  'marketing.f.hasTelegram': 'Has Telegram',
  'marketing.vacDue': 'due (30 days)',
  'marketing.vacOverdue': 'overdue',
  'marketing.sample': 'Sample (pseudonymised)',
  'marketing.deleteTitle': 'Delete segment?',
  'marketing.exportTitle': 'Export segment',
  'marketing.exportText': 'State the purpose — it is audited.',
  'marketing.purpose': 'Purpose',
  'marketing.min': 'min',
  'marketing.max': 'max',
  'marketing.title': 'Title',
  'marketing.ch.any': 'Client\'s preferred',
  'marketing.ch.push': 'App push',
  'marketing.ch.telegram': 'Telegram',
  'marketing.ch.sms': 'SMS',
  'marketing.st.draft': 'draft',
  'marketing.st.scheduled': 'scheduled',
  'marketing.st.sending': 'sending',
  'marketing.st.sent': 'sent',
  'marketing.st.cancelled': 'cancelled',
  'marketing.cancel': 'Cancel campaign',
  'marketing.schedule': 'Schedule',
  'marketing.scheduledToast': 'Campaign scheduled',
  'marketing.segmentClients': 'Segment clients',
  'marketing.eligible': 'Eligible',
  'marketing.noConsent': 'No consent',
  'marketing.noChannel': 'No channel',
  'marketing.results': 'Results over {n} days',
  'marketing.conversion': 'Conversion',
  'inbox.assigned': 'Assignee',
  'inbox.clients': 'Clients',
  'inbox.closed': 'Closed',
  'inbox.open': 'Open',
  'inbox.noAppAccount': 'This client has no app/Telegram account — no conversation yet.',
  'inbox.notLinked': 'Account not linked to a client',
  'inbox.pick': 'Pick a conversation',
  'inbox.search': 'Name or phone',
  'inbox.takeMine': 'Assign to me',
  'rooms.cameras': 'Cameras',
  'rooms.sessions': 'Room sessions',
  'rooms.disabled': 'disabled',
  'rooms.gap': 'gap {s} s',
  'rooms.gapLabel': 'Max gap between clips, s',
  'rooms.inRoom': 'in «{room}»',
  'rooms.lastClip': 'Last clip',
  'rooms.mapText': 'The previous assignment ends at this moment; sessions are rebuilt.',
  'rooms.notAssigned': 'no room assigned',
  'rooms.recordings': '{n} recordings',
  'rooms.remap': 'Change room',
  'rooms.room': 'Room',
  'rooms.roomIdHint': 'The Enote room list needs clients.read — rooms from history are shown.',
  'rooms.searchTranscripts': 'Search room transcripts',
  'fact.discount_amount': 'Discount',
  'journey.notFound': 'No journey found',
  'journey.notFoundHint': 'No journey has been built for this record yet.',
  'draft.fromAi': 'AI draft',
  'draft.published': 'Sent to the client {when}',
  'draft.awaiting': 'Awaiting the doctor',
  'draft.stale': 'stale',
  'draft.staleHint': 'Visit data changed after generation — review carefully or regenerate.',
  'doctor.allDoctors': 'whole clinic',
  'draft.st.ready': 'ready',
  'draft.st.stale': 'stale',
  'draft.st.generating': 'generating',
  'draft.st.failed': 'failed',
  'doctor.queue': 'Queue',
  'doctor.queueEmpty': 'All recommendations approved',

  // inventory
  'nav.inventory': 'Inventory',
  'inventory.subtitle': 'Stock and movements from Enote',
  'inventory.subtitleSynced': 'Stock and movements from Enote · updated {when}',
  'inventory.tabStock': 'Stock',
  'inventory.tabAlerts': 'Alerts',
  'inventory.warehouses': 'Warehouses',
  'inventory.allWarehouses': 'All warehouses',
  'inventory.everything': 'Including disposal and virtual',
  'inventory.kind.physical': 'Clinic stores',
  'inventory.kind.personal': 'Doctors’ stock',
  'inventory.kind.disposal': 'Disposal',
  'inventory.kind.virtual': 'Virtual',
  'inventory.kindShort.physical': 'store',
  'inventory.kindShort.personal': 'doctor',
  'inventory.kindShort.disposal': 'disposal',
  'inventory.kindShort.virtual': 'virtual',
  'inventory.otherWarehouses': 'Disposal and virtual ({n})',
  'inventory.item': 'Item',
  'inventory.group': 'Group',
  'inventory.unit': 'Unit',
  'inventory.qty': 'Quantity',
  'inventory.qtyStock': 'On hand',
  'inventory.min': 'Minimum',
  'inventory.minShort': 'min {n}',
  'inventory.minTotal': 'Minimum (total)',
  'inventory.value': 'Value',
  'inventory.lastMovement': 'Last movement',
  'inventory.inStock': 'Items in stock',
  'inventory.positions': '{n} listed',
  'inventory.totalValue': 'Stock value',
  'inventory.atCost': 'at cost',
  'inventory.unitCost': 'Unit cost',
  'inventory.costValue': 'Value at cost',
  'inventory.salePrice': 'Sale price',
  'inventory.saleValue': 'Value at sale price',
  'inventory.totalSale': 'Value at sale prices',
  'inventory.atSalePrice': 'Enote price list',
  'inventory.negative': 'Negative balances',
  'inventory.lowStock': 'Below minimum',
  'inventory.low': 'low',
  'inventory.showOnly': 'show only these',
  'inventory.empty': 'No stock in the selected warehouses',
  'inventory.search': 'Search: name, SKU, group',
  'inventory.onlyNegative': 'Negative only',
  'inventory.onlyLow': 'Below minimum',
  'inventory.includeZero': 'Include zero',
  'inventory.alert.negative': 'Negative balances',
  'inventory.alert.low': 'Below minimum',
  'inventory.alert.dead': 'No movement for {days}+ days',
  'inventory.alert.disposal': 'In disposal warehouses',
  'inventory.alertNone': 'All good',
  'inventory.deadPartial': 'Movement history starts on {date}: items without movement since then.',
  'inventory.warehouse': 'Warehouse',
  'inventory.allStock': 'all warehouses',
  'inventory.never': 'never',
  'inventory.more': '{n} more — narrow the warehouse',
  'inventory.byWarehouse': 'By warehouse',
  'inventory.noBalance': 'No stock in any warehouse',
  'inventory.movements': 'Movements',
  'inventory.tabBalance': 'Stock',
  'inventory.tabSales': 'Sales',
  'inventory.sales.open': 'Sales over a period',
  'inventory.sales.last30': '30 days',
  'inventory.sales.last90': '90 days',
  'inventory.sales.last365': '12 months',
  'inventory.sales.ytd': 'Year to date',
  'inventory.sales.byDay': 'By day',
  'inventory.sales.byWeek': 'By week',
  'inventory.sales.byMonth': 'By month',
  'inventory.sales.qty': 'Sold',
  'inventory.sales.revenue': 'Revenue',
  'inventory.sales.avgPrice': 'Average price',
  'inventory.sales.documents': 'Receipts and visits',
  'inventory.sales.retail': 'Retail receipts',
  'inventory.sales.visits': 'In visits',
  'inventory.sales.metricQty': 'Quantity',
  'inventory.sales.metricRevenue': 'Revenue',
  'inventory.sales.empty': 'No sales in this period',
  'inventory.sales.chart': 'Sales over the period',
  'inventory.sales.note': 'Retail receipts and visit lines from Enote; revenue after discounts.',
  'inventory.since': 'since {date}',
  'inventory.noMovements': 'No movements in this period',
  'inventory.openVisit': 'visit',
  'inventory.thresholds': 'Minimum stock',
  'inventory.doc.supply': 'Receipt',
  'inventory.doc.transfer': 'Transfer',
  'inventory.doc.supplier_return': 'Return to supplier',
  'inventory.doc.customer_return': 'Customer return',
  'inventory.doc.visit': 'Visit',
  'inventory.doc.sale': 'Sale',
  'inventory.doc.inventory': 'Stock count',
  'inventory.doc.write_off': 'Write-off',
  'inventory.doc.surplus': 'Surplus',
  'inventory.doc.service_act': 'Service act',
  'inventory.doc.assembly': 'Assembly',

  // clinic processes (checklists)
  'nav.processes': 'Processes',
  'nav.processMine': 'My checklists',
  'nav.processCalendar': 'Compliance calendar',
  'nav.processTemplates': 'Templates & schedules',
  'nav.processNorms': 'Norms',
  'permGroup.processes': 'Clinic processes',
  'perm.process.run': 'Completing checklists',
  'perm.process.manage': 'Checklist templates, schedules and norms',
  'process.mineTitle': 'My checklists',
  'process.mineSubtitle': 'Checklists for you and your role, overdue first. Times are Kyiv time.',
  'process.start': 'Start a checklist',
  'process.startTitle': 'Start a checklist',
  'process.startHint': 'Pick a checklist: it is added to your list and opens right away.',
  'process.startButton': 'Start',
  'process.template': 'Checklist',
  'process.noTemplates': 'No checklists yet',
  'process.noTemplatesHint': 'Create your own or add the clinic’s standard checklists from the regulations.',
  'process.noArea': 'No area',
  'process.scope': 'Whose checklists',
  'process.scopeMine': 'Mine',
  'process.scopeAll': 'All',
  'process.statusFilter': 'Status',
  'process.statusOpenAll': 'All open',
  'process.area': 'Area',
  'process.allAreas': 'All areas',
  'process.branch': 'Branch',
  'process.allBranches': 'All branches',
  'process.anyBranch': 'Any branch',
  'process.zone': 'Zone / room',
  'process.zoneHint': 'For example “Room 2”, “Ward, box 3”',
  'process.onlyOverdue': 'Overdue only',
  'process.emptyMine': 'All checklists are done',
  'process.emptyMineHint': 'New ones appear on schedule. To run a checklist now, press “Start a checklist”.',
  'process.showDone': 'Show completed in the last {n} days',
  'process.recentDone': 'Recently completed',
  'process.noneDone': 'Nothing completed in this period.',
  'process.dueAt': 'due {when}',
  'process.doneAtBy': 'Completed {when} · {who}',
  'process.overdue': 'Overdue',
  'process.attention': 'Needs attention',
  'process.attentionHint': 'A value is outside its allowed range',
  'process.status.planned': 'Planned',
  'process.status.open': 'Not started',
  'process.status.in_progress': 'In progress',
  'process.status.done': 'Done',
  'process.status.cancelled': 'Cancelled',
  'process.progress': '{answered} of {total}',
  'process.missingRequired': 'required left: {n}',
  'process.assignee': 'Assignee: {who}',
  'process.version': 'version {n}',
  'process.versionShort': 'v{n}',
  'process.cancelledReason': 'Cancelled: {reason}',
  'process.saving': 'Saving…',
  'process.saved': 'All changes saved',
  'process.notSaved': 'Not saved — check the values',
  'process.cancelRun': 'Cancel checklist',
  'process.complete': 'Complete',
  'process.fillRequired': 'Fill in the required items ({n}) marked in red.',
  'process.required': 'Required',
  'process.requiredMissing': 'Not filled in',
  'process.onlyRole': 'Filled in by: {role}',
  'process.outOfRange': 'Out of range! Allowed: {range}',
  'process.allowedRange': 'Allowed: {range}',
  'process.normLine': 'Norm “{title}”: {value}',
  'process.normToConfirm': 'Needs confirmation',
  'process.normConfirmed': 'Confirmed',
  'process.answeredBy': '{who} · {when}',
  'process.signaturePlaceholder': 'Full name',
  'process.choose': 'Choose…',
  'process.photoPlaceholder': 'File ids, comma-separated',
  'process.photoNote': 'Photo upload comes in the next version. For now enter a file id or link.',
  'process.unknownType': 'Unknown item type: {type}',
  'process.notANumber': 'Enter a number, e.g. 4.5',
  'process.cancelTitle': 'Cancel this checklist?',
  'process.cancelHint': 'The checklist closes without being done. The reason is kept in the log.',
  'process.cancelReason': 'Reason',
  'process.calendarSubtitle': 'Scheduled duties for the month: planned, done and overdue. Kyiv time.',
  'process.print': 'Print journal',
  'process.modeGrid': 'Month',
  'process.modeList': 'List',
  'process.legend': 'Legend',
  'process.showLess': 'show less',
  'process.calendarEmpty': 'No scheduled duties this month',
  'process.journalTitle': 'Compliance journal · {period}',
  'process.col.when': 'Date and time',
  'process.col.checklist': 'Checklist',
  'process.col.zone': 'Zone',
  'process.col.status': 'Status',
  'process.col.who': 'Completed by',
  'process.col.rhythm': 'Rhythm',
  'process.col.assignee': 'Assignee',
  'process.col.due': 'Time to complete',
  'process.col.escalation': 'Escalation',
  'process.col.next': 'Next',
  'process.col.active': 'On',
  'process.col.version': 'Version',
  'process.col.state': 'State',
  'process.col.updated': 'Updated',
  'process.col.norm': 'Norm',
  'process.col.value': 'Value',
  'process.col.unit': 'Unit',
  'process.col.source': 'Source',
  'process.templatesSubtitle': 'Clinic checklists and the schedules that assign them to staff',
  'process.tabTemplates': 'Templates',
  'process.tabSchedules': 'Schedules',
  'process.showArchived': 'Show archived',
  'process.seedDefaults': 'Add standard checklists',
  'process.seeded': 'Standard checklists, paused schedules and norms added',
  'process.active': 'Active',
  'process.archived': 'Archived',
  'process.editNamed': 'Edit “{title}”',
  'process.newTemplate': 'New checklist',
  'process.editTemplate': 'Edit checklist',
  'process.editHint': 'Changed items are published as a new version; runs already started keep theirs.',
  'process.createTemplate': 'Create',
  'process.publish': 'Publish',
  'process.versionNote': 'Changed items = new version',
  'process.templateCreated': 'Checklist created (version 1)',
  'process.versionPublished': 'Version {n} published',
  'process.templateSavedSame': 'Saved. Items did not change, so the version is the same.',
  'process.sectionN': 'Section {n}',
  'process.itemN': 'Item {n}',
  'process.moveUp': 'Move up',
  'process.moveDown': 'Move down',
  'process.removeSection': 'Remove section',
  'process.removeItem': 'Remove item',
  'process.addItem': 'Add item',
  'process.addSection': 'Add section',
  'process.anyone': 'Anyone',
  'process.noNorm': 'No norm',
  'process.field.title': 'Title',
  'process.field.key': 'Key',
  'process.field.keyHint': 'Latin letters, digits and “_”; fixed after creation',
  'process.field.keyFixed': 'The key cannot be changed',
  'process.field.description': 'Description and source (regulation)',
  'process.field.active': 'Active — can be started',
  'process.field.sectionTitle': 'Section title',
  'process.field.label': 'Item text',
  'process.field.type': 'Type',
  'process.field.itemKey': 'Item key',
  'process.field.role': 'Filled in by',
  'process.field.unit': 'Unit',
  'process.field.min': 'Minimum',
  'process.field.max': 'Maximum',
  'process.field.choices': 'Choices',
  'process.field.choicesHint': 'One per line, at least two',
  'process.field.hint': 'Hint',
  'process.field.norm': 'Norm',
  'process.itemType.check': 'Tick',
  'process.itemType.number': 'Number',
  'process.itemType.text': 'Text',
  'process.itemType.choice': 'Choice',
  'process.itemType.photo': 'Photo',
  'process.itemType.signature': 'Signature (name)',
  'process.err.required': 'Required',
  'process.err.key': 'Only a–z, digits and “_”',
  'process.err.keyDuplicate': 'This key is already used',
  'process.err.choices': 'At least two choices',
  'process.err.number': 'Must be a number',
  'process.err.range': 'Minimum is greater than maximum',
  'process.err.noItems': 'Add at least one item',
  'process.err.unknown': 'Unknown value',
  'process.err.fix': 'Fix the highlighted fields',
  'process.err.everyN': 'From 1 to 1000',
  'process.schedulesHint': 'A schedule creates checklists automatically. Standard schedules start paused: review them and switch them on.',
  'process.newSchedule': 'New schedule',
  'process.editScheduleTitle': 'Edit schedule',
  'process.editSchedule': 'Edit schedule “{title}”',
  'process.noSchedules': 'No schedules yet',
  'process.scheduleActive': 'Schedule “{title}” is on',
  'process.schedulePaused': 'Schedule paused',
  'process.scheduleResumed': 'Schedule resumed',
  'process.person': 'A person',
  'process.nobody': 'Nobody',
  'process.paused': 'Paused',
  'process.rhythmPreview': 'Rhythm: {rhythm}',
  'process.field.scheduleTitle': 'Title in the schedule',
  'process.field.scheduleTitleHint': 'Optional, e.g. “Drug room check (evening)”',
  'process.field.freq': 'Repeat',
  'process.field.everyN': 'Every N',
  'process.field.startsAt': 'First time',
  'process.field.startsAtHint': 'Kyiv time; later ones keep the same time of day',
  'process.field.until': 'Until (optional)',
  'process.field.weekdays': 'Only on weekdays',
  'process.field.months': 'Only in months',
  'process.field.assigneeRole': 'Assigned role',
  'process.field.due': 'Complete within, min',
  'process.field.escalate': 'Escalate after overdue, min',
  'process.field.escalateHint': 'Empty — no escalation',
  'process.field.escalateRole': 'Notify',
  'process.field.scheduleOn': 'Schedule is on',
  'process.freq.hours': 'Hourly / every N hours',
  'process.freq.days': 'Daily / every N days',
  'process.freq.weeks': 'Weekly / every N weeks',
  'process.freq.months': 'Monthly / every N months',
  'process.freq.years': 'Yearly',
  'process.rhythm.hourly': 'hourly',
  'process.rhythm.everyHours': 'every {n} h|every {n} h|every {n} h',
  'process.rhythm.daily': 'daily',
  'process.rhythm.everyDays': 'every {n} day|every {n} days|every {n} days',
  'process.rhythm.weekly': 'weekly',
  'process.rhythm.everyWeeks': 'every {n} week|every {n} weeks|every {n} weeks',
  'process.rhythm.monthly': 'monthly',
  'process.rhythm.everyMonths': 'every {n} month|every {n} months|every {n} months',
  'process.rhythm.yearly': 'yearly',
  'process.rhythm.everyYears': 'every {n} year|every {n} years|every {n} years',
  'process.rhythm.onWeekday': 'on {day}',
  'process.rhythm.dayOfMonth': 'on day {day}',
  'process.rhythm.at': 'at {time}',
  'process.weekdaysShort': 'Mon|Tue|Wed|Thu|Fri|Sat|Sun',
  'process.monthsShort': 'Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec',
  'process.dur.min': '{n} min',
  'process.dur.hours': '{n} h',
  'process.dur.days': '{n} d',
  'process.normsSubtitle': 'Numbers and deadlines from the regulations that checklists rely on. Every change is logged.',
  'process.normsSearch': 'Search norms',
  'process.noNorms': 'No norms yet',
  'process.normsToConfirm': 'Need confirmation: {n} — the documents disagree.',
  'process.normHistoryOf': 'History of “{title}”',
  'process.normEditOf': 'Edit “{title}”',
  'process.normHistory': 'Change history',
  'process.normNoHistory': 'No changes yet',
  'process.normValue': 'Value (JSON)',
  'process.normInvalidJson': 'Invalid JSON. Number: 15, text: "18:00", range: {"min": 2, "max": 8}',
  'process.normPreview': 'Shown as: {value}',
  'process.normReason': 'Reason for the change',
  'process.normReasonHint': 'E.g. the order number or meeting decision',
  'process.normUnit': 'Unit: {unit}',
  'process.system': 'System',
  'process.area.clinic': 'Clinic',
  'process.area.surgery': 'Surgery',
  'process.area.ward': 'Ward (ICU)',
  'process.area.cash': 'Cash desk',
  'process.area.call_center': 'Call centre',
  'process.area.safety': 'Safety',
  'process.area.management': 'Management',
  'process.branch.kharkiv': 'Kharkiv',
  'process.branch.kyiv': 'Kyiv',
  'today.overdueChecklists': 'Overdue checklists',
  'nav.vrit': 'ICU ward',
  'nav.vritHandover': 'ICU shift handover',
  'perm.vrit.read': 'ICU board and monitoring',
  'perm.vrit.manage': 'ICU: admission, handovers, reports, discharge',
  'vrit.title': 'ICU ward',
  'vrit.subtitle': 'Boxes, patients, categories and the countdown to the next check. Refreshes every minute.',
  'vrit.allBranches': 'All branches',
  'vrit.branchFilter': 'Branch',
  'vrit.admit': 'Admit a patient',
  'vrit.boxes': 'Boxes',
  'vrit.tariffs': 'Tariffs',
  'vrit.morning': 'Morning handover',
  'vrit.statOccupied': 'Occupied',
  'vrit.statFree': 'Free',
  'vrit.statOverdue': 'Overdue checks',
  'vrit.statReports': 'No owner report today',
  'vrit.statHandovers': 'Handovers awaiting acknowledgement',
  'vrit.visitHours': 'Visiting: {from}–{to}, up to {min} min',
  'vrit.visitHoursHint': 'Critical patients — any time by agreement with the ICU doctor.',
  'vrit.toConfirm': 'to confirm',
  'vrit.monitoringNorms': 'Monitoring frequency',
  'vrit.noBoxes': 'No boxes yet',
  'vrit.noBoxesHint': 'Add the boxes and cages of each branch — then the board shows places for patients.',
  'vrit.noBoxesHintStaff': 'Ask an administrator or ICU doctor to add the boxes.',
  'vrit.free': 'Free',
  'vrit.admitHere': 'Admit here',
  'vrit.cat.n': 'Cat. {n}',
  'vrit.cat.vent': 'Ventilation',
  'vrit.category': 'Category',
  'vrit.min': '{n} min',
  'vrit.hours': '{n} h',
  'vrit.days': '{n} d',
  'vrit.overdueBy': 'overdue by {d}',
  'vrit.checkIn': 'check in {d}',
  'vrit.continuous': 'continuous (a dedicated person)',
  'vrit.perHour': '{from}–{to} times an hour',
  'vrit.every': 'every {d}',
  'vrit.daysIn': 'Day {n}',
  'vrit.kg': 'kg',
  'vrit.hr': 'HR',
  'vrit.rr': 'RR',
  'vrit.perDay': '{amount}/day',
  'vrit.debt': 'Debt {amount}',
  'vrit.deposit': 'Deposit {amount}',
  'vrit.balanceZero': 'Balance 0',
  'vrit.reportSent': 'Report sent',
  'vrit.reportNotSent': 'Report not sent yet',
  'vrit.warnings': 'Attention: {list}',
  'vrit.warn.no_consent_pack': 'consent pack not signed',
  'vrit.warn.no_prepayment': 'no prepayment',
  'vrit.warn.unvaccinated': 'unvaccinated',
  'vrit.warn.risk_not_informed': 'owner not informed of the risk in writing',
  'vrit.warn.no_weight': 'no weight',
  'vrit.warn.no_tariff': 'tariff not configured',
  'vrit.kind.standard': 'Standard',
  'vrit.kind.oxygen': 'Oxygen',
  'vrit.kind.isolation': 'Isolation',
  'vrit.kind.neonatal': 'Neonatal',
  'vrit.vacc.vaccinated': 'Vaccinated',
  'vrit.vacc.unvaccinated': 'Unvaccinated',
  'vrit.vacc.unknown': 'Status unknown',
  'vrit.band.lt10': 'up to 10 kg',
  'vrit.band.10_25': '10–25 kg',
  'vrit.band.25_50': '25–50 kg',
  'vrit.band.gt50': 'over 50 kg',
  'vrit.status.admitted': 'In the ward',
  'vrit.status.discharged': 'Discharged',
  'vrit.status.died': 'Died',
  'vrit.status.transferred': 'Transferred',
  'vrit.admitTitle': 'Admit a patient to the ICU',
  'vrit.admitHint': 'Patient and visit come from Enote. The tariff is proposed by category and weight.',
  'vrit.searchPatient': 'Patient',
  'vrit.searchPlaceholder': 'Pet name, owner or chip',
  'vrit.searchHint': 'Type at least 2 characters',
  'vrit.noPatients': 'Nobody found',
  'vrit.alreadyAdmitted': 'already in the ward',
  'vrit.box': 'Box',
  'vrit.chooseBox': 'Choose a box',
  'vrit.noFreeBoxes': 'No free boxes',
  'vrit.visit': 'Enote visit',
  'vrit.noVisit': 'No visit',
  'vrit.weight': 'Weight, kg',
  'vrit.weightHint': 'Latest Enote weight: {w} kg',
  'vrit.diagnosis': 'Diagnosis',
  'vrit.vaccination': 'Vaccination',
  'vrit.docs': 'Admission documents',
  'vrit.doc.consent_pack': 'Inpatient consent + payment agreement signed',
  'vrit.doc.prepayment': 'Prepayment received',
  'vrit.doc.risk_informed': 'Owner informed of the risk in writing (unvaccinated)',
  'vrit.unvaccinatedWarn': 'Unvaccinated patients are admitted only by indication and with the owner informed in writing.',
  'vrit.admitButton': 'Admit',
  'vrit.admitted': 'Patient admitted',
  'vrit.boxesTitle': 'Boxes and cages',
  'vrit.boxesHint': 'Code as on the box label. A box with a patient cannot be taken out of use.',
  'vrit.boxCode': 'Box code',
  'vrit.boxKind': 'Kind',
  'vrit.addBox': 'Add box',
  'vrit.inUse': 'In use',
  'vrit.tariffsTitle': 'ICU day tariffs',
  'vrit.tariffsHint': 'Category × weight. Empty = not configured. Saved when you leave the field.',
  'vrit.tariffsHidden': 'Tariffs are money: only roles with payments access see them.',
  'vrit.tabMonitoring': 'Monitoring',
  'vrit.tabHandover': 'Handovers',
  'vrit.tabReport': 'Owner report',
  'vrit.tabDischarge': 'Discharge',
  'vrit.owner': 'Owner',
  'vrit.admittedAt': 'Admitted',
  'vrit.responsible': 'Responsible',
  'vrit.lastCheck': 'Last check',
  'vrit.never': 'none yet',
  'vrit.openInEnote': 'Patient card',
  'vrit.changeCategory': 'Change category',
  'vrit.moveTo': 'Move to box',
  'vrit.monitorTitle': 'New check',
  'vrit.monitorHint': 'Saving a check restarts the countdown.',
  'vrit.field.temperature_c': 'Temperature, °C',
  'vrit.field.heart_rate': 'Heart rate, bpm',
  'vrit.field.resp_rate': 'Resp. rate, /min',
  'vrit.field.weight_kg': 'Weight, kg',
  'vrit.field.mucosa': 'Mucosa',
  'vrit.field.mental': 'Mental status',
  'vrit.field.appetite': 'Appetite',
  'vrit.field.stool': 'Stool',
  'vrit.field.urine': 'Urine',
  'vrit.field.note': 'Note',
  'vrit.saveCheck': 'Save check',
  'vrit.checkSaved': 'Check saved',
  'vrit.invalidNumber': 'Enter a number',
  'vrit.addNote': 'Add note',
  'vrit.notePlaceholder': 'A note without a check (does not restart the countdown)',
  'vrit.log': 'Log',
  'vrit.logEmpty': 'No entries yet. Add the first check.',
  'vrit.ev.admission': 'Admitted',
  'vrit.ev.monitoring': 'Check',
  'vrit.ev.note': 'Note',
  'vrit.ev.category_change': 'Category {from} → {to}',
  'vrit.ev.box_change': 'Box {from} → {to}',
  'vrit.ev.update': 'Details changed',
  'vrit.ev.owner_report': 'Owner report',
  'vrit.ev.discharge': 'Closed: {outcome}',
  'vrit.newHandover': 'New patient handover',
  'vrit.scenario': 'Scenario',
  'vrit.sc.stable': 'Stable from consultation',
  'vrit.sc.critical': 'Critical from admissions',
  'vrit.sc.after_urgent': 'After urgent surgery',
  'vrit.sc.after_planned': 'After planned surgery',
  'vrit.sc.unvaccinated': 'Unvaccinated',
  'vrit.sc.shift': 'Shift handover',
  'vrit.handOver': 'Hand over',
  'vrit.handoverSaved': 'Handover saved — waits for an ICU doctor to acknowledge',
  'vrit.receive': 'Received',
  'vrit.received': 'Received by {who}, {when}',
  'vrit.waiting': 'Awaiting acknowledgement',
  'vrit.handedBy': '{who}, {when}',
  'vrit.noHandovers': 'No handovers yet',
  'vrit.requiredMissing': 'Fill the required fields: {n}',
  'vrit.reportTitle': 'Daily owner report',
  'vrit.reportHint': 'Sent to the owner’s app and Telegram bot. Send photos and videos separately for now.',
  'vrit.rp.stool': 'Stool',
  'vrit.rp.urination': 'Urination',
  'vrit.rp.appetite': 'Appetite',
  'vrit.rp.activity': 'Activity',
  'vrit.rp.mucosa': 'Mucosa',
  'vrit.rp.temperature': 'Temperature',
  'vrit.rp.dynamics': 'Dynamics',
  'vrit.rp.tests': 'Tests',
  'vrit.reportText': 'Text for the owner',
  'vrit.preview': 'Preview',
  'vrit.send': 'Send to the owner',
  'vrit.reportSentOk': 'Report sent',
  'vrit.reportNoRecipients': 'The owner has no app or bot — call them. The report is saved.',
  'vrit.recipients': 'Recipients: {n}',
  'vrit.balanceIncluded': 'The account balance will be appended',
  'vrit.balanceOff': 'Balance is not appended (setting vrit.owner_report_include_balance is off)',
  'vrit.alreadySentToday': 'A report was already sent today',
  'vrit.pastReports': 'Sent reports',
  'vrit.noReports': 'No reports sent yet',
  'vrit.dischargeHint': 'Only an ICU doctor discharges: first the checklist (recommendations, consent, owner training, receipts), then «Discharge».',
  'vrit.startChecklist': 'Open the discharge checklist',
  'vrit.checklistNotStarted': 'The discharge checklist is not open yet',
  'vrit.checklistDone': 'The discharge checklist is complete',
  'vrit.checklistOpen': 'The discharge checklist is open — complete it',
  'vrit.dischargeButton': 'Discharge',
  'vrit.otherOutcome': 'Other outcome',
  'vrit.outcome.died': 'Died',
  'vrit.outcome.transferred': 'Transferred',
  'vrit.outcomeNote': 'What happened',
  'vrit.closeStay': 'Close the stay',
  'vrit.stayClosed': 'Stay closed',
  'vrit.closedAt': '{status}: {when}, {who}',
  'vrit.morningTitle': 'ICU morning shift handover',
  'vrit.morningSubtitle': 'Every patient with fields prefilled from the board and the log. Complete, hand over — the incoming shift acknowledges.',
  'vrit.pendingTitle': 'Awaiting acknowledgement',
  'vrit.noPatientsInWard': 'No patients in this branch’s ward right now',
  'vrit.general': 'General',
  'vrit.handOverShift': 'Hand over the shift',
  'vrit.shiftSaved': 'Shift handed over — awaiting acknowledgement',
  'vrit.lastShift': 'Last handover: {when}, {who}',
  'vrit.recentNotes': 'Last 24 h',
  'vrit.required': 'Required',
  'vrit.juniorCannotReceive': 'Only a doctor can receive a patient or a shift and discharge.',
  // Stock control (B13)
  'process.area.stock': 'Stock',
  'stock.tabOrder': 'To order',
  'stock.tabCounts': 'Counts',
  'stock.tabExpiry': 'Expiry',
  'stock.toOrderCount': 'To order',
  'stock.levelsCount': 'Items with min/optimal: {n}',
  'stock.orderValue': 'Estimated order value',
  'stock.consumptionWindow': 'Consumption over',
  'stock.days': '{n} d',
  'stock.leadDays': 'Plus {n} d delivery time',
  'stock.noLead': 'Order up to the optimal level',
  'stock.showAllLevels': 'All items with min/optimal',
  'stock.importLevels': 'Import min/optimal',
  'stock.csvForSupplier': 'CSV for the supplier',
  'stock.exported': 'Items exported: {n}',
  'stock.nothingToOrder': 'Nothing to order — every balance is at or above its minimum',
  'stock.noLevels': 'No minimum and optimal quantities yet',
  'stock.noLevelsHint': 'Import them from the «Склади» sheet or set a minimum in the item card on the Stock tab.',
  'stock.balancesAsOf': 'Enote balances as of {when}',
  'stock.minOpt': 'Min / opt',
  'stock.dailyUse': 'Use/day',
  'stock.cover': 'Lasts',
  'stock.toOrder': 'Order',
  'stock.below': 'below minimum',
  'stock.soon': 'running out',
  'stock.importHint': 'Paste rows from the sheet: name or SKU, minimum, optimal (tab, «;» or «,» separated). A header row is skipped.',
  'stock.check': 'Check',
  'stock.importN': 'Import {n}',
  'stock.levelTotal': 'Total over all warehouses',
  'stock.importText': 'Rows from the sheet',
  'stock.importExample': 'For example: Sterile bandage;5;20',
  'stock.importPreview': 'Matched items: {matched}, with problems: {issues}',
  'stock.importLine': 'Line {n}',
  'stock.imported': 'Levels imported: {n}',
  'stock.issue.not_found': 'item not found',
  'stock.issue.ambiguous': 'several items with this name',
  'stock.issue.bad_number': 'invalid number',
  'stock.issue.optimal_below_min': 'optimal is below minimum',
  'stock.optimal': 'Optimal',
  'stock.optShort': 'opt {n}',
  'stock.enoteReadOnly': 'Counts and batches are kept in Bridge; Enote balances are not changed.',
  'stock.plans': 'Count schedule',
  'stock.setupPlans': 'Create schedules from the norm',
  'stock.plansCreated': 'Schedules created paused — review and turn them on',
  'stock.noWarehouses': 'No warehouses yet — wait for the Enote sync',
  'stock.rhythm': 'Frequency',
  'stock.whoCounts': 'Who counts',
  'stock.nextCount': 'Next',
  'stock.lastCount': 'Last',
  'stock.paused': 'paused',
  'stock.suggested': 'By the norm: {rhythm}',
  'stock.noPlan': 'No schedule',
  'stock.openCount': 'Open count sheet',
  'stock.diffN': 'differences: {n}',
  'stock.never': 'none yet',
  'stock.countNow': 'Count now',
  'stock.editPlan': 'Change the schedule of «{name}»',
  'stock.freqOne.days': 'daily',
  'stock.freqOne.weeks': 'weekly',
  'stock.freqOne.months': 'monthly',
  'stock.freqMany.days': 'every {n} days',
  'stock.freqMany.weeks': 'every {n} weeks',
  'stock.freqMany.months': 'every {n} months',
  'stock.freqUnit.days': 'Days',
  'stock.freqUnit.weeks': 'Weeks',
  'stock.freqUnit.months': 'Months',
  'stock.planTitle': 'Count: {name}',
  'stock.freq': 'Unit',
  'stock.everyN': 'Every N',
  'stock.firstCount': 'First count',
  'stock.firstCountHint': 'Default: tomorrow at 09:00',
  'stock.dueHours': 'Due within, hours',
  'stock.dueHint': 'Default: daily — 10 h, every 2–3 days — 1 day, otherwise 3 days',
  'stock.countRole': 'Role',
  'stock.countPerson': 'Or a specific person',
  'stock.doctor': 'Doctor (warehouse owner)',
  'stock.doctorHint': 'A personal warehouse is counted by its doctor; shortages go to the payroll report',
  'stock.byRole': 'By role',
  'stock.planActive': 'Schedule is on',
  'stock.history': 'Count sheets',
  'stock.status': 'Status',
  'stock.allStatuses': 'All statuses',
  'stock.sheetStatus.open': 'Open',
  'stock.sheetStatus.done': 'Completed',
  'stock.sheetStatus.cancelled': 'Cancelled',
  'stock.noCounts': 'No counts yet',
  'stock.noCountsHint': 'Set up the schedule above or press «Count now» next to a warehouse.',
  'stock.when': 'When',
  'stock.counted': 'Counted',
  'stock.shortage': 'Shortage',
  'stock.surplus': 'Surplus',
  'stock.shortageValue': 'Shortage value',
  'stock.shortagesTitle': 'Personal warehouse shortages of the month (payroll)',
  'stock.month': 'Month',
  'stock.noShortages': 'No shortages this month',
  'stock.expired': 'Expired',
  'stock.expiringSoon': 'Expiring within {n} d',
  'stock.inWindow': 'Batches within {n} d',
  'stock.alertsAt': 'Alerts at {days} d',
  'stock.searchBatch': 'Search item or series',
  'stock.window': 'Window',
  'stock.withinDays': 'Within {n} days',
  'stock.addBatch': 'Add batch',
  'stock.addBatchHint': 'For drugs whose expiry is not in Enote: series from the package, date and quantity.',
  'stock.noExpiring': 'No batches expiring soon',
  'stock.noExpiringHint': 'Dates come from Enote (when present) and from batches added here with «Add batch».',
  'stock.batch': 'Series',
  'stock.expiresOn': 'Expires on',
  'stock.sourceLocal': 'Bridge',
  'stock.expiredBadge': 'expired',
  'stock.daysLeft': '{n} d',
  'stock.markUsed': 'Used up: {name}',
  'stock.markDisposed': 'Disposed: {name}',
  'stock.err.qty': 'Quantity must be a number ≥ 0',
  'stock.change': 'Change',
  'stock.backToCounts': 'Counts',
  'stock.filter.all': 'All',
  'stock.filter.uncounted': 'Not counted',
  'stock.filter.diff': 'With a difference',
  'stock.sheetTitle': 'Count: {name}',
  'stock.doctorIs': 'Doctor: {name}',
  'stock.dueAt': 'Due: {when}',
  'stock.snapshotAt': 'Enote balances as of {when}',
  'stock.snapshotCreated': 'Sheet created {when}',
  'stock.openChecklist': 'Checklist',
  'stock.differences': 'Differences',
  'stock.addItem': 'Add item',
  'stock.completeCount': 'Complete the count',
  'stock.emptySheet': 'Enote shows nothing in this warehouse',
  'stock.emptySheetHint': 'If there is something on the shelf, add it with «Add item».',
  'stock.expected': 'Enote',
  'stock.countedQty': 'Counted',
  'stock.difference': 'Difference',
  'stock.note': 'Note',
  'stock.added': 'added',
  'stock.countedOf': 'Counted quantity: {name}',
  'stock.noteOf': 'Note: {name}',
  'stock.completeHint': 'Differences: {diffs}, shortage {shortage} units. The sheet cannot be edited after completion.',
  'stock.countDone': 'Count completed',
  'stock.uncountedLeft': 'Items not counted: {n}',
  'stock.fillExpected': 'Treat the remaining {n} items as matching Enote',
  'stock.countNote': 'Remarks',
  'stock.countNoteHint': 'Reasons for shortages, expired drugs — saved to the checklist',
  'stock.addItemHint': 'The item is on the shelf but not in the Enote balance of this warehouse.',
  'stock.add': 'Add',
  'stock.openSheet': 'Open the count sheet →',
  // staff and HR (B11)
  'nav.staff': 'Staff',
  'nav.staffBriefings': 'Briefing journal',
  'nav.staffMe': 'My training',
  'perm.hr.read': 'Staff: cards, briefings, certificates, skills',
  'perm.hr.manage': 'Staff: edit cards, briefing journal, tests',
  'process.area.hr': 'Staff',
  'today.staffDue': 'Staff: briefings and documents',
  'hr.title': 'Staff',
  'hr.subtitle': 'Employee cards, onboarding and offboarding, briefings, certificates and medical exams, skills and tests. Only position, branch, employer, dates, status and mentor — no salaries, passports or tax numbers.',
  'hr.tabEmployees': 'Employees',
  'hr.tabMatrix': 'Skills matrix',
  'hr.tabTests': 'Tests',
  'hr.employee': 'Employee',
  'hr.fullName': 'Full name',
  'hr.fullNameHint': 'May stay empty when an account or Enote employee is chosen',
  'hr.account': 'Bridge account',
  'hr.noAccount': 'No account',
  'hr.enoteEmployee': 'Enote employee',
  'hr.position': 'Position',
  'hr.role': 'Role',
  'hr.roleHint': 'For the skills matrix',
  'hr.branch': 'Branch',
  'hr.employer': 'Employer (ФОП / ТОВ)',
  'hr.status': 'Status',
  'hr.status.trainee': 'Trainee / course listener',
  'hr.status.probation': 'Probation',
  'hr.status.staff': 'Staff',
  'hr.status.left': 'Left',
  'hr.allWorking': 'All working',
  'hr.hiredOn': 'Start date',
  'hr.probationUntil': 'Probation ends',
  'hr.leftOn': 'Leaving date',
  'hr.mentor': 'Mentor',
  'hr.highRisk': 'High-risk work',
  'hr.highRiskHint': 'High-risk work (repeat OHS briefing every 3 months)',
  'hr.privacyNote': 'Bridge does not store salaries, passport data, tax numbers, addresses or phone numbers of employees — they stay in the HR records.',
  'hr.addEmployee': 'Add employee',
  'hr.editEmployee': 'Employee card',
  'hr.employeeFormHint': 'Link the card to a Bridge account (notifications, own card) and to the Enote employee.',
  'hr.sync': 'Cards from accounts',
  'hr.syncDone': 'Cards created: {n}',
  'hr.searchEmployee': 'Search by name or position',
  'hr.attention': 'Attention',
  'hr.overdueN': 'overdue: {n}',
  'hr.dueSoonN': 'soon: {n}',
  'hr.noEmployees': 'No employee cards yet',
  'hr.noEmployeesHint': 'Press «Cards from accounts» — Bridge creates cards for everyone with an account and takes the position from Enote. Add trainees without an account by hand.',
  'hr.noEmployeesRole': 'No employees with this role',
  'hr.dueTitle': 'Needs attention',
  'hr.nothingDue': 'All briefings and documents are in order',
  'hr.needsAttention': 'Needs attention',
  'hr.days.today': 'today',
  'hr.days.in': 'in {n} d',
  'hr.days.ago': 'overdue by {n} d',
  'hr.state.missing': 'Not given',
  'hr.state.overdue': 'Overdue',
  'hr.state.due': 'Soon',
  'hr.state.ok': 'OK',
  'hr.state.expired': 'Expired',
  'hr.state.expiring': 'Expiring',
  'hr.state.valid': 'Valid',
  'hr.state.open': 'No expiry',
  'hr.state.ending': 'Ending',
  'hr.tab.onboarding': 'Onboarding',
  'hr.tab.briefings': 'Briefings',
  'hr.tab.certificates': 'Certificates and exams',
  'hr.tab.skills': 'Skills',
  'hr.startOnboarding': 'Start onboarding',
  'hr.startOffboarding': 'Start offboarding',
  'hr.offboardingNeedsDate': 'Set the leaving date on the card first',
  'hr.noRuns': 'Onboarding has not been started',
  'hr.noRunsHint': '«Start onboarding» creates checklists: documents and accesses, briefings and admission, the first week with the mentor and meetings after 4 and 8 weeks, 6 and 12 months.',
  'hr.area': 'Area',
  'hr.area.ohs': 'Occupational safety',
  'hr.area.fire': 'Fire safety',
  'hr.area.civil': 'Civil defence',
  'hr.allAreas': 'All areas',
  'hr.kind': 'Briefing kind',
  'hr.kind.introductory': 'Introductory',
  'hr.kind.primary': 'Primary',
  'hr.kind.repeat': 'Repeat',
  'hr.kind.unscheduled': 'Unscheduled',
  'hr.kind.targeted': 'Targeted',
  'hr.kindHint.introductory': 'New employees, interns — up to 1 hour',
  'hr.kindHint.primary': 'Before work at the workplace; the repeat interval starts here',
  'hr.kindHint.repeat': 'OHS: every 3 months (high risk) / 6 months; fire safety 6 months',
  'hr.kindHint.unscheduled': 'New rules, new equipment, violations, a break over 30/60 days',
  'hr.kindHint.targeted': 'Accident response, work under a permit',
  'hr.allKinds': 'All kinds',
  'hr.topic': 'Instruction / topic',
  'hr.topicHint': 'E.g. «ІЗВР-1 introductory briefing»',
  'hr.reason': 'Reason',
  'hr.givenOn': 'Date',
  'hr.instructor': 'Given by',
  'hr.instructorHint': 'Empty — you',
  'hr.nextDue': 'Next',
  'hr.nextOn': 'next {date}',
  'hr.never': 'never given',
  'hr.signature': 'Confirmation',
  'hr.acknowledge': 'I confirm',
  'hr.acknowledged': 'Confirmed',
  'hr.notAcknowledged': 'Not confirmed',
  'hr.recordBriefing': 'Record a briefing',
  'hr.recordBriefingHint': 'A group can be recorded at once. Primary and repeat briefings set the next date from the norms.',
  'hr.recordFor': 'Record ({n})',
  'hr.whoBriefed': 'Briefed: {n}',
  'hr.noBriefings': 'No journal entries yet',
  'hr.noBriefingsHint': 'Enter the last briefing from the paper journal — Bridge counts the next date from it.',
  'hr.journalTitle': 'Briefing journal',
  'hr.journalSubtitle': 'Occupational safety, fire safety and civil defence. The paper journal stays the legal document — this page can be printed.',
  'hr.journalEmptyHint': 'Press «Record a briefing» and move the entries from paper journals №3 and №4.',
  'hr.briefingsDue': 'Briefings to give: {n}',
  'hr.print': 'Print',
  'hr.deleteEntry': 'Delete entry',
  'hr.deleteEntryTitle': 'Delete the journal entry?',
  'hr.certKind': 'Kind',
  'hr.cert.ohs_training': 'Occupational safety training',
  'hr.cert.fire_minimum': 'Fire-safety minimum',
  'hr.cert.radiation': 'Radiation safety',
  'hr.cert.medical_exam': 'Medical examination',
  'hr.cert.first_aid': 'First aid',
  'hr.cert.electrical': 'Electrical safety group',
  'hr.cert.other': 'Other',
  'hr.certTitle': 'Title',
  'hr.issuedOn': 'Issued',
  'hr.validUntil': 'Valid until',
  'hr.validUntilHint': 'Reminder 30 days before',
  'hr.noExpiry': 'no expiry',
  'hr.note': 'Note',
  'hr.noteHint': 'No document numbers or personal data',
  'hr.addCertificate': 'Add certificate',
  'hr.editCertificate': 'Certificate',
  'hr.certificateHint': 'OHS training (officials every 3 years, others yearly), fire-safety minimum, radiation safety, medical exams.',
  'hr.deleteCertificate': 'Delete the certificate?',
  'hr.noCertificates': 'No certificates or medical exams yet',
  'hr.noCertificatesHint': 'Add the medical exam date and certificates with validity — Bridge reminds before they expire.',
  'hr.skill': 'Skill / topic',
  'hr.level': 'Level',
  'hr.level.0': 'Not started',
  'hr.level.1': 'Theory',
  'hr.level.2': 'Supervised',
  'hr.level.3': 'Independent',
  'hr.levelOf': 'Level: {skill}',
  'hr.addRep': 'Performed once more: {skill}',
  'hr.addReps': 'Add repetitions',
  'hr.repsHint': 'Performed / required by the norm',
  'hr.repsDone': '{n} of {required} repetitions performed',
  'hr.notRequired': 'not for this role',
  'hr.otherSkills': 'Other',
  'hr.noSkills': 'No skills for this role yet',
  'hr.noSkillsHint': 'HR fills the skills catalog; «Add defaults» on the Tests tab adds the assistants\' primary training (18 topics).',
  'hr.matrixHint': 'HR and the employee\'s mentor record levels. «Independent» needs the required repetitions.',
  'hr.tests': 'Tests',
  'hr.test': 'Test',
  'hr.newTest': 'New test',
  'hr.editTest': 'Test',
  'hr.seed': 'Add defaults',
  'hr.noTests': 'No tests yet',
  'hr.noTestsHint': '«Add defaults» creates a safety test, onboarding checklists and the assistants\' skills.',
  'hr.noTestsForMe': 'No tests for you yet',
  'hr.testMeta': 'Questions: {n} · pass score {score}%',
  'hr.archived': 'archived',
  'hr.takeTest': 'Take',
  'hr.retake': 'Take again',
  'hr.testTitle': 'Test title',
  'hr.testKey': 'Key',
  'hr.testKeyHint': 'Latin letters, e.g. vaccination_2026',
  'hr.testDescription': 'Description',
  'hr.testSkill': 'Skill',
  'hr.testSkillHint': 'Passing raises the level to at least «Theory»',
  'hr.passScore': 'Pass score, %',
  'hr.testActive': 'Active',
  'hr.questionN': 'Question {n}',
  'hr.choices': 'Choices',
  'hr.choicesHint': 'One choice per line',
  'hr.correctChoices': 'Correct choices',
  'hr.addQuestion': 'Add question',
  'hr.removeQuestion': 'Remove question',
  'hr.testResults': 'Test results',
  'hr.noAttempts': 'Nobody has taken a test yet',
  'hr.score': 'Result',
  'hr.finishedAt': 'When',
  'hr.passed': 'passed',
  'hr.failed': 'failed',
  'hr.multiHint': 'several correct',
  'hr.submitTest': 'Submit answers',
  'hr.answerAll': 'Answer every question',
  'hr.answerRight': 'Correct',
  'hr.answerWrong': 'Wrong',
  'hr.resultPassed': 'Test passed: {score}%',
  'hr.resultFailed': 'Test failed: {score}% ({need}% needed)',
  'hr.resultCorrect': 'Correct answers: {n} of {total}',
  'hr.meTitle': 'My training',
  'hr.meSubtitle': 'My briefings, certificates and medical exams, skills and tests.',
  'hr.myTests': 'Tests',
  'hr.noCard': 'No employee card yet',
  'hr.noCardHint': 'An administrator (HR) creates it under «Staff». Then your briefings, skills and tests appear here.',
  'hr.err.name': 'Enter a name or choose an account',
  'hr.err.leftOn': 'An employee who left needs a leaving date',
  'hr.err.leftOrder': 'The leaving date is before the start date',
  'hr.err.probationOrder': 'Probation ends before the start date',
  'hr.err.mentorSelf': 'An employee cannot be their own mentor',
  'hr.err.invalid': 'Check the value',
  'hr.err.required': 'Required',
  'hr.err.future': 'A briefing cannot be recorded in advance',
  'hr.err.certDates': '«Valid until» is before the issue date',
  'hr.err.key': 'Only a-z, 0-9 and _',
  'hr.err.questionText': 'Enter the question text',
  'hr.err.questionChoices': 'At least two choices are needed',
  'hr.err.questionCorrect': 'Tick the correct choice',
  'hr.err.repsShort': '«Independent» after {n} repetitions',
}
